(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[818],{

/***/ 9457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zo": function() { return /* reexport */ Configs; },
  "lC": function() { return /* reexport */ NODE_ENV; },
  "$X": function() { return /* reexport */ node_env; },
  "Ts": function() { return /* reexport */ __DEV__; },
  "te": function() { return /* reexport */ nav_items; }
});

// UNUSED EXPORTS: __VERBOSE__, siteConfig

// EXTERNAL MODULE: ./node_modules/.pnpm/loglevel@1.8.0/node_modules/loglevel/lib/loglevel.js
var loglevel = __webpack_require__(919);
var loglevel_default = /*#__PURE__*/__webpack_require__.n(loglevel);
;// CONCATENATED MODULE: ./src/types/node-env.ts
var NodeEnv;
(function(NodeEnv) {
    NodeEnv["DEVELOP"] = "development";
    NodeEnv["PROD"] = "production";
    NodeEnv["TEST"] = "test";
})(NodeEnv || (NodeEnv = {}));
/* harmony default export */ var node_env = (NodeEnv);

;// CONCATENATED MODULE: ./src/types/index.ts


;// CONCATENATED MODULE: ./configs/constants.ts
/* provided dependency */ var process = __webpack_require__(4248);



var getNodeEnv = function() {
    return "production" || 0;
};
var NODE_ENV = getNodeEnv();
loglevel_default().info("NODE_ENV: ".concat(NODE_ENV));
var __DEV__ = NODE_ENV === node_env.DEVELOP;
loglevel_default().debug("__DEV__: ".concat(__DEV__));
var __VERBOSE__ = "true" === process.env.VERBOSE;
loglevel_default().debug("__VERBOSE__: ".concat(__VERBOSE__));
var PATH_ROOT = "";
var PATH_ASSETS = "".concat(PATH_ROOT, "/assets");
var PATH_ASSETS_IMAGES = "".concat(PATH_ASSETS, "/images");
var PATH_ASSETS_IMAGES_SECTIONS = "".concat(PATH_ASSETS_IMAGES, "/sections");
var PATH_ASSETS_IMAGES_BG = "".concat(PATH_ASSETS_IMAGES, "/bg");
var PATH_ASSETS_IMAGES_LOGO = "".concat(PATH_ASSETS_IMAGES, "/logo");
var PATH_ASSETS_IMAGES_SVG = "".concat(PATH_ASSETS_IMAGES, "/svg");

;// CONCATENATED MODULE: ./configs/configs.ts
/* provided dependency */ var configs_process = __webpack_require__(4248);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
// TODO: group all default values here for readability
var DEFAULT_ZOOM_LEVEL = parseInt(configs_process.env.NEXT_PUBLIC_DEFAULT_ZOOM_LEVEL) || 3;
var DEFAULT_ZOOM_LEVEL_PC = parseInt(configs_process.env.NEXT_PUBLIC_DEFAULT_ZOOM_LEVEL_PC) || 3;
var DEFAULT_ZOOM_LEVEL_MOBILE = parseInt(configs_process.env.NEXT_PUBLIC_DEFAULT_ZOOM_LEVEL_MOBILE) || 5;
var Configs = /*#__PURE__*/ function() {
    "use strict";
    function Configs() {
        _classCallCheck(this, Configs);
    }
    _createClass(Configs, null, [
        {
            key: "getEnvVars",
            value: function getEnvVars() {
                return {
                    basePath: configs_process.env.BASE_PATH,
                    brandEN: configs_process.env.NEXT_PUBLIC_BRAND_EN || "INNO&M",
                    brandKO: configs_process.env.NEXT_PUBLIC_BRAND_KO || "이노앤엠",
                    disableMap: configs_process.env.NEXT_PUBLIC_DISABLE_MAP === "true",
                    kakaoMapApiKey: "807c663f23e4cc79cec3f709ca216c65" || 0
                };
            }
        },
        {
            key: "getEnvVar",
            value: function getEnvVar(key, defaultValue) {
                return configs_process.env[key] || defaultValue;
            }
        },
        {
            key: "isCiMode",
            value: function isCiMode() {
                return configs_process.env.CI === "true";
            }
        },
        {
            key: "isVerboseMode",
            value: function isVerboseMode() {
                return configs_process.env.VERBOSE === "true";
            }
        },
        {
            key: "getReactSpringConfigs",
            value: function getReactSpringConfigs() {
                return {
                    stiff2: {
                        mass: 1,
                        tension: 280,
                        friction: 30
                    }
                };
            }
        },
        {
            key: "getKakaoMapConfigs",
            value: function getKakaoMapConfigs() {
                var // OPTIONAL
                log = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined, isMobile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined, zoomLevel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : DEFAULT_ZOOM_LEVEL, zoomable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                log === null || log === void 0 ? void 0 : log.debug("isMobile: ".concat(isMobile, ", zoomLevel: ").concat(zoomLevel, ", zoomable: ").concat(zoomable));
                var markerPositions = [
                    [
                        parseFloat("37.5019717967829") || 37.501752191269595,
                        parseFloat("127.043833557891") || 127.03406025057782, 
                    ], 
                ];
                var centerOffset = isMobile ? [
                    parseFloat("0.0025") || +0.0025,
                    parseFloat("0.002") || +0.002, 
                ] : [
                    parseFloat("-0.0001") || -0.0001,
                    parseFloat("-0.0055") || -0.0055, 
                ];
                var centerLatLng = [
                    markerPositions[0][0] + centerOffset[0],
                    markerPositions[0][1] + centerOffset[1], 
                ];
                log === null || log === void 0 ? void 0 : log.debug("markerPositions: ".concat(JSON.stringify(markerPositions)));
                log === null || log === void 0 ? void 0 : log.debug("centerOffset: ".concat(JSON.stringify(centerOffset)));
                log === null || log === void 0 ? void 0 : log.debug("centerLatLng: ".concat(JSON.stringify(centerLatLng)));
                return {
                    centerLatLng: centerLatLng,
                    markerPositions: markerPositions,
                    // OPTIONAL
                    zoomLevel: zoomLevel,
                    zoomable: zoomable
                };
            }
        },
        {
            key: "getKakaoMapZoomLevel",
            value: function getKakaoMapZoomLevel(critBreakpoint, curBreakpoint) {
                if (!curBreakpoint || !critBreakpoint) return DEFAULT_ZOOM_LEVEL;
                if (curBreakpoint > critBreakpoint) return DEFAULT_ZOOM_LEVEL_PC;
                return DEFAULT_ZOOM_LEVEL_MOBILE;
            }
        }
    ]);
    return Configs;
}();


;// CONCATENATED MODULE: ./configs/nav-items.ts
var navItems = [
    {
        label: "Home",
        href: "/"
    },
    {
        label: "About",
        href: "/about"
    },
    {
        label: "Business",
        href: "/business/viral",
        children: [
            {
                label: "바이럴 마케팅",
                href: "/business/viral"
            },
            // {
            //   label: `SNS 운영대행`,
            //   href: `/business/sns`,
            // },
            {
                label: "언론 송출",
                href: "/business/media"
            },
            {
                label: "검색 광고",
                href: "/business/searchad"
            },
            {
                label: "종합 마케팅",
                href: "/business/marketing"
            }, 
        ]
    },
    {
        label: "Contact",
        href: "/contact"
    }, 
];
/* harmony default export */ var nav_items = (navItems);

// EXTERNAL MODULE: ./configs/site-config.ts
var site_config = __webpack_require__(5560);
;// CONCATENATED MODULE: ./configs/index.ts






/***/ }),

/***/ 4324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ motionFadeUpProps; },
  "l": function() { return /* binding */ motionFadeUpSlowProps; }
});

;// CONCATENATED MODULE: ./configs/motion-values.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var motionBasicProps = {
    initial: "initial",
    exit: "exit"
};
var visibleInViewProps = _objectSpread({}, motionBasicProps, {
    whileInView: "enter",
    // onViewportEnter: `enter`,
    // onViewportExit: `exit`,
    viewport: {
        margin: "-50px 0px",
        once: false
    }
});
var fadeInProps = {
    slow: {
        transition: {
            delay: 0.3,
            duration: 0.6
        }
    },
    normal: {
        transition: {
            delay: 0.2,
            duration: 0.4
        }
    }
};
var fadeUpProps = {
    variants: {
        initial: {
            opacity: 0,
            y: 20
        },
        enter: {
            opacity: 1,
            y: 0
        },
        exit: {
            opacity: 0,
            y: -20
        }
    }
};

;// CONCATENATED MODULE: ./configs/motion-presets.ts

function motion_presets_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function motion_presets_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            motion_presets_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var motionFadeUpSlowProps = motion_presets_objectSpread({}, visibleInViewProps, fadeInProps.slow, fadeUpProps);
var motionFadeUpProps = motion_presets_objectSpread({}, visibleInViewProps, fadeInProps.normal, fadeUpProps);


/***/ }),

/***/ 7994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uH": function() { return /* reexport */ motion_box; },
  "xn": function() { return /* reexport */ motion_heading; }
});

// UNUSED EXPORTS: MotionMain

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+system@1.11.2_@emotion+react@11.8.1_@emotion+styled@11.8.1_react@17.0.2/node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 3 modules
var chakra_ui_system_esm = __webpack_require__(3879);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@1.7.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(9034);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.2.8_react-dom@17.0.2_react@17.0.2/node_modules/framer-motion/dist/es/motion/utils/valid-prop.mjs
var valid_prop = __webpack_require__(1406);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.2.8_react-dom@17.0.2_react@17.0.2/node_modules/framer-motion/dist/es/render/dom/motion.mjs + 129 modules
var motion = __webpack_require__(8593);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
;// CONCATENATED MODULE: ./src/components/chakra-ui/framer-motion/motion-box.tsx




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var MotionBoxRef = (0,chakra_ui_system_esm/* forwardRef */.Gp)(function(props, ref) {
    var chakraProps = Object.fromEntries(// do not pass framer props to DOM element
    Object.entries(props).filter(function(param) {
        var _param = _slicedToArray(param, 1), key = _param[0];
        return !(0,valid_prop/* isValidMotionProp */.Z)(key);
    }));
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, _objectSpread({
        ref: ref
    }, chakraProps)));
});
var MotionBox = (0,motion/* motion */.E)(MotionBoxRef);
MotionBox.displayName = "MotionBox";
/* harmony default export */ var motion_box = (MotionBox);

;// CONCATENATED MODULE: ./src/components/chakra-ui/framer-motion/motion-heading.tsx




function motion_heading_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function motion_heading_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function motion_heading_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function motion_heading_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function motion_heading_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function motion_heading_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            motion_heading_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function motion_heading_slicedToArray(arr, i) {
    return motion_heading_arrayWithHoles(arr) || motion_heading_iterableToArrayLimit(arr, i) || motion_heading_unsupportedIterableToArray(arr, i) || motion_heading_nonIterableRest();
}
function motion_heading_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return motion_heading_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return motion_heading_arrayLikeToArray(o, minLen);
}
var MotionHeadingRef = (0,chakra_ui_system_esm/* forwardRef */.Gp)(function(props, ref) {
    var chakraProps = Object.fromEntries(// do not pass framer props to DOM element
    Object.entries(props).filter(function(param) {
        var _param = motion_heading_slicedToArray(param, 1), key = _param[0];
        return !(0,valid_prop/* isValidMotionProp */.Z)(key);
    }));
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, motion_heading_objectSpread({
        ref: ref
    }, chakraProps)));
});
var MotionHeading = (0,motion/* motion */.E)(MotionHeadingRef);
MotionHeading.displayName = "MotionHeading";
/* harmony default export */ var motion_heading = (MotionHeading);

// EXTERNAL MODULE: ./src/components/chakra-ui/framer-motion/motion-main.tsx
var motion_main = __webpack_require__(6279);
;// CONCATENATED MODULE: ./src/components/chakra-ui/framer-motion/index.ts





/***/ }),

/***/ 6279:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3879);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1406);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8593);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9496);




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var MotionMainRef = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function(props, ref) {
    var chakraProps = Object.fromEntries(// do not pass framer props to DOM element
    Object.entries(props).filter(function(param) {
        var _param = _slicedToArray(param, 1), key = _param[0];
        return !(0,framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .isValidMotionProp */ .Z)(key);
    }));
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .chakra.main */ .m$.main, _objectSpread({
        ref: ref
    }, chakraProps)));
});
var MotionMain = (0,framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion */ .E)(MotionMainRef);
MotionMain.displayName = "MotionMain";
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (MotionMain)));


/***/ }),

/***/ 3890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kq": function() { return /* reexport */ next_page_button; },
  "nC": function() { return /* reexport */ text_underline; },
  "pX": function() { return /* reexport */ text_underline_divider; }
});

// UNUSED EXPORTS: SnsFloatingButtons

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@1.7.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(9034);
// EXTERNAL MODULE: ./node_modules/.pnpm/@react-spring+web@9.4.3_react-dom@17.0.2_react@17.0.2/node_modules/@react-spring/web/dist/react-spring-web.esm.js
var react_spring_web_esm = __webpack_require__(6249);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@4.3.1_react@17.0.2/node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(999);
;// CONCATENATED MODULE: ./src/components/next-page-button.tsx





var NextPageButton = function(param) {
    var _href = param.href, href = _href === void 0 ? null : _href, _show = param.// OPTIONAL
    show, show = _show === void 0 ? false : _show;
    var wrapSpring = (0,react_spring_web_esm.useSpring)({
        display: href && show ? "block" : "none",
        opacity: href && show ? 0.8 : 0
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_esm.animated.div, {
        style: wrapSpring,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
            type: "button",
            href: href,
            pos: "fixed",
            bottom: {
                base: "100px",
                md: "110px"
            },
            right: {
                base: "20px",
                md: "37px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                bg: "gray.400",
                borderRadius: "50%",
                w: "50px",
                h: "50px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaAngleDoubleRight */.hPV, {
                    color: "blackAlpha.700",
                    size: "22px"
                })
            })
        })
    }));
};
/* harmony default export */ var next_page_button = (NextPageButton);

// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(9803);
// EXTERNAL MODULE: ./src/utils/index.ts + 10 modules
var utils = __webpack_require__(7925);
;// CONCATENATED MODULE: ./src/components/SnsFloatingButtons/SnsFloatingButtons.tsx

// REF: https://stackoverflow.com/questions/29209244/css-floating-action-button







var SnsFloatingButtons = function(param) {
    var _show = param.// OPTIONAL
    show, show = _show === void 0 ? true : _show;
    var wrapSpring = useSpring({
        opacity: show ? 1 : 0
    });
    return(/*#__PURE__*/ _jsxs(animated.div, {
        className: styles.buttonWrap,
        style: wrapSpring,
        children: [
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: cn(styles.button, styles.main),
                children: /*#__PURE__*/ _jsx(BsChatFill, {
                    className: styles.icon
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.subButtonWrap,
                children: [
                    /*#__PURE__*/ _jsx(Link, {
                        type: "button",
                        href: "/contact",
                        _hover: {
                            color: "brand.300"
                        },
                        className: cn(styles.button, styles.sub),
                        children: /*#__PURE__*/ _jsx(RiEditBoxFill, {
                            className: styles.icon
                        })
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        type: "button",
                        href: "tel:".concat(t("company.phoneNum")),
                        _hover: {
                            color: "brand.300"
                        },
                        className: cn(styles.button, styles.sub),
                        children: /*#__PURE__*/ _jsx(RiPhoneFill, {
                            className: styles.icon
                        })
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        type: "button",
                        href: "mailto:".concat(t("company.contactEmail")),
                        _hover: {
                            color: "brand.300"
                        },
                        className: cn(styles.button, styles.sub),
                        children: /*#__PURE__*/ _jsx(RiMailFill, {
                            className: styles.icon
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var SnsFloatingButtons_SnsFloatingButtons = ((/* unused pure expression or super */ null && (SnsFloatingButtons)));

// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+color-mode@1.4.6_react@17.0.2/node_modules/@chakra-ui/color-mode/dist/chakra-ui-color-mode.esm.js
var chakra_ui_color_mode_esm = __webpack_require__(9262);
;// CONCATENATED MODULE: ./src/components/text-underline.tsx



var TextUnderline = function(param) {
    var children = param.children, _colorDark = param.// OPTIONAL
    colorDark, colorDark = _colorDark === void 0 ? "whiteAlpha.900" : _colorDark, _colorLight = param.colorLight, colorLight = _colorLight === void 0 ? "gray.700" : _colorLight, _hide = param.hide, hide = _hide === void 0 ? false : _hide, _show = param.// hoverColorDark,
    // hoverColorLight,
    show, show = _show === void 0 ? true : _show, _underlineColorDark = param.underlineColorDark, underlineColorDark = _underlineColorDark === void 0 ? "brand.200" : _underlineColorDark, _underlineColorLight = param.underlineColorLight, underlineColorLight = _underlineColorLight === void 0 ? "brand.300" : _underlineColorLight, _underlineHeight = param.underlineHeight, underlineHeight = _underlineHeight === void 0 ? "30%" : _underlineHeight, _underlineLeft = param.underlineLeft, underlineLeft = _underlineLeft === void 0 ? 0 : _underlineLeft, _underlineRight = param.underlineRight, underlineRight = _underlineRight === void 0 ? 0 : _underlineRight, _underlineWidth = param.underlineWidth, underlineWidth = _underlineWidth === void 0 ? "full" : _underlineWidth;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        as: "span",
        color: (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)(colorLight, colorDark),
        position: "relative",
        zIndex: 0,
        _after: {
            bg: (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)(underlineColorLight, underlineColorDark),
            bottom: underlineRight,
            content: "\"\"",
            display: hide ? "none" : "block",
            h: underlineHeight,
            left: underlineLeft,
            opacity: show ? 1 : 0,
            position: "absolute",
            transitionProperty: "opacity",
            transitionDuration: "normal",
            transitionTimingFunction: "ease-in-out",
            w: underlineWidth,
            zIndex: -1
        },
        children: children
    }));
};
/* harmony default export */ var text_underline = (TextUnderline);

;// CONCATENATED MODULE: ./src/components/text-underline-divider.tsx



var TextUnderlineDivider = function(param) {
    var children = param.children, _colorDark = param.// OPTIONAL
    colorDark, colorDark = _colorDark === void 0 ? "whiteAlpha.900" : _colorDark, _colorLight = param.colorLight, colorLight = _colorLight === void 0 ? "gray.700" : _colorLight, _hide = param.hide, hide = _hide === void 0 ? false : _hide, _show = param.show, show = _show === void 0 ? true : _show, _underlineColorDark = param.underlineColorDark, underlineColorDark = _underlineColorDark === void 0 ? "brand.200" : _underlineColorDark, _underlineColorLight = param.underlineColorLight, underlineColorLight = _underlineColorLight === void 0 ? "brand.300" : _underlineColorLight, _underlineHeight = param.underlineHeight, underlineHeight = _underlineHeight === void 0 ? "0.4rem" : _underlineHeight, _underlineMarginBottom = param.underlineMarginBottom, underlineMarginBottom = _underlineMarginBottom === void 0 ? "0.75rem" : _underlineMarginBottom, _underlineMarginTop = param.underlineMarginTop, underlineMarginTop = _underlineMarginTop === void 0 ? "0.25rem" : _underlineMarginTop, _underlineWidth = param.underlineWidth, underlineWidth = _underlineWidth === void 0 ? "3.5rem" : _underlineWidth;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
        color: (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)(colorLight, colorDark),
        flexDir: "column",
        position: "relative",
        zIndex: 0,
        _after: {
            bg: (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)(underlineColorLight, underlineColorDark),
            content: "\"\"",
            display: hide && "none",
            h: underlineHeight,
            mb: underlineMarginBottom,
            mt: underlineMarginTop,
            mx: "auto",
            opacity: show ? 1 : 0,
            transition: "opacity normal ease-in-out",
            w: underlineWidth,
            zIndex: -1
        },
        children: children
    });
};
/* harmony default export */ var text_underline_divider = (TextUnderlineDivider);

;// CONCATENATED MODULE: ./src/components/index.ts






/***/ }),

/***/ 1762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Oc": function() { return /* reexport */ brand_logo; },
  "td": function() { return /* reexport */ naver_logo_icon; }
});

// UNUSED EXPORTS: brandLogoStyles

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+system@1.11.2_@emotion+react@11.8.1_@emotion+styled@11.8.1_react@17.0.2/node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 3 modules
var chakra_ui_system_esm = __webpack_require__(3879);
;// CONCATENATED MODULE: ./src/components/svgs/brand-logo.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var brandLogoStyles = {
    default: {
        fill1: "#00a1e9",
        fill2: "#0b3190",
        fill3: "#181c62",
        // OPTIONAL
        fillOpacity: 1
    },
    light: {
        fill1: "white",
        fill2: "white",
        fill3: "white",
        // OPTIONAL
        fillOpacity: 1
    }
};
var BrandLogo = function(param) {
    var _logoStyleType = param.// OPTIONAL
    logoStyleType, logoStyleType = _logoStyleType === void 0 ? "default" : _logoStyleType, svgProps = param.svgProps;
    var logoStyle = (0,react.useMemo)(function() {
        return brandLogoStyles[logoStyleType];
    }, [
        logoStyleType
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.svg */.m$.svg, _objectSpread({
        viewBox: "0 0 755.90533 133.0032"
    }, svgProps, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "g10",
            transform: "matrix(1.3333333,0,0,-1.3333333,0,133.0032)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "g12",
                    transform: "translate(6.0687,99.7524)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "path14",
                        d: "m 0,0 -6.069,-4.454 v -6.094 L 0,-6.094 6.068,-10.548 v 6.094 z",
                        style: {
                            fill: logoStyle.fill1,
                            fillOpacity: logoStyle.fillOpacity,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "g16",
                    transform: "translate(0,82.494)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "path18",
                        d: "m 0,0 v -6.094 l 6.069,4.454 6.068,-4.454 V 0 L 6.069,4.454 Z",
                        style: {
                            fill: logoStyle.fill2,
                            fillOpacity: logoStyle.fillOpacity,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "g20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        id: "g22",
                        clipPath: "url(#clipPath26)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g28",
                                transform: "translate(241.2803,44.8486)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path30",
                                    d: "M 0,0 C 0,18.039 14.675,32.713 32.71,32.713 50.749,32.713 65.423,18.039 65.423,0 V -2.207 H 77.56 V 0 c 0,24.729 -20.121,44.849 -44.85,44.849 -24.729,0 -44.846,-20.12 -44.846,-44.849 0,-24.729 20.117,-44.849 44.846,-44.849 h 2.207 v 12.137 H 32.71 C 14.675,-32.712 0,-18.038 0,0",
                                    style: {
                                        fill: logoStyle.fill3,
                                        fillOpacity: logoStyle.fillOpacity,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g32",
                                transform: "translate(313.1636,89.6977)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path34",
                                    d: "M 0,0 H -2.206 V -12.136 H 0 c 18.039,0 32.713,-14.675 32.713,-32.713 0,-18.038 -14.674,-32.713 -32.713,-32.713 -18.036,0 -32.71,14.675 -32.71,32.713 v 2.206 h -12.136 v -2.206 c 0,-24.729 20.117,-44.849 44.846,-44.849 24.729,0 44.849,20.12 44.849,44.849 C 44.849,-20.12 24.729,0 0,0",
                                    style: {
                                        fill: logoStyle.fill1,
                                        fillOpacity: logoStyle.fillOpacity,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g36",
                                transform: "translate(6.0684,74.144)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path38",
                                    d: "M 0,0 -6.068,-4.454 V -71.225 H 6.068 v 66.771 z",
                                    style: {
                                        fill: logoStyle.fill3,
                                        fillOpacity: logoStyle.fillOpacity,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g40",
                                transform: "translate(98.8389,21.6626)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path42",
                                    d: "m 0,0 -55.235,65.115 h -12.154 v -83.858 l 12.137,0.005 v 65.113 l 55.23,-65.113 6.092,-0.005 6.066,0.005 V 65.115 H 0 Z",
                                    style: {
                                        fill: logoStyle.fill3,
                                        fillOpacity: logoStyle.fillOpacity,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g44",
                                transform: "translate(398.7329,65.5913)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path46",
                                    d: "m 0,0 c -0.78,0.819 -1.446,1.748 -1.98,2.758 l -0.002,0.005 c -0.223,0.415 -0.485,1.206 -0.485,2.622 0,1.278 0.279,2.357 0.885,3.403 0.586,1.014 1.343,1.754 2.379,2.329 1.086,0.601 2.245,0.894 3.545,0.894 1.345,0 2.506,-0.286 3.551,-0.872 1.024,-0.578 1.775,-1.324 2.368,-2.349 0.608,-1.052 0.89,-2.134 0.89,-3.405 0,-2.204 -0.698,-3.728 -2.217,-5.006 L 3.331,-3.704 Z m -7.068,-26.877 8.732,6.878 21.966,-24.419 c -2.237,-2.98 -5.081,-5.372 -8.475,-7.126 -3.213,-1.655 -6.542,-1.868 -9.083,-1.868 -3.409,0 -6.611,0.758 -9.52,2.254 -2.877,1.476 -5.071,3.396 -6.708,5.863 -1.541,2.325 -2.291,4.771 -2.291,7.478 0,2.049 0.455,3.98 1.39,5.901 0.946,1.942 2.3,3.646 3.989,5.039 m 49.266,3.288 0.134,2.332 H 30.185 l -0.125,-2.074 c -0.153,-2.505 -0.423,-5.585 -1.125,-8.838 l -17.443,19.393 4.822,3.51 0.427,0.36 c 4.281,3.646 6.546,8.587 6.546,14.291 0,3.392 -0.847,6.581 -2.519,9.479 -1.683,2.905 -4.012,5.211 -6.923,6.85 -5.721,3.213 -13.149,3.215 -18.93,0.017 -2.961,-1.641 -5.317,-3.951 -7.002,-6.869 -1.67,-2.883 -2.517,-6.072 -2.517,-9.477 0,-3.148 0.641,-5.945 1.901,-8.311 1.034,-1.957 2.362,-3.81 3.795,-5.314 l 2.443,-2.718 -8.216,-6.466 c -3.12,-2.569 -5.572,-5.657 -7.288,-9.18 -1.735,-3.562 -2.614,-7.335 -2.614,-11.213 0,-5.103 1.453,-9.876 4.314,-14.186 2.776,-4.185 6.568,-7.531 11.274,-9.951 4.64,-2.385 9.708,-3.594 15.067,-3.594 3.168,0 7.973,0.258 13.099,2.504 l 1.321,0.58 v 0.025 c 0.076,0.035 0.151,0.074 0.227,0.112 4.342,2.239 8.08,5.176 11.145,8.753 l 8.421,-9.361 h 16.32 l -18.219,20.258 c 3.174,7.917 3.618,15.673 3.812,19.088",
                                    style: {
                                        fill: logoStyle.fill3,
                                        fillOpacity: logoStyle.fillOpacity,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g48",
                                transform: "translate(197.6772,21.6626)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path50",
                                    d: "m 0,0 -55.235,65.115 h -12.154 v -83.858 l 12.137,0.005 v 65.113 l 55.231,-65.113 6.091,-0.005 6.066,0.005 V 65.115 H 0 Z",
                                    style: {
                                        fill: logoStyle.fill3,
                                        fillOpacity: logoStyle.fillOpacity,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g52",
                                transform: "translate(550.7549,86.7778)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path54",
                                    d: "M 0,0 -35.835,-68.554 -71.67,0 h -11.762 v -83.858 h 12.137 v 56.946 l 29.767,-56.946 h 11.386 l 34.18,65.389 V -83.858 H 16.174 V 0 Z",
                                    style: {
                                        fill: logoStyle.fill3,
                                        fillOpacity: logoStyle.fillOpacity,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            })
                        ]
                    })
                })
            ]
        })
    })));
};
/* harmony default export */ var brand_logo = (BrandLogo);

;// CONCATENATED MODULE: ./src/components/svgs/naver-logo-icon.tsx



function naver_logo_icon_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function naver_logo_icon_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            naver_logo_icon_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var NaverLogoIcon = function(param) {
    var // OPTIONAL
    svgProps = param.svgProps;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_system_esm/* chakra.svg */.m$.svg, naver_logo_icon_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 512 512",
        height: "1.15em",
        width: "1.15em"
    }, svgProps, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M9 32V480H181.366V255.862L331.358 480H504V32H331.358V255.862L181.366 32H9Z"
            })
        ]
    })));
};
/* harmony default export */ var naver_logo_icon = (NaverLogoIcon);

;// CONCATENATED MODULE: ./src/components/svgs/index.ts





/***/ }),

/***/ 4093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Container */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9034);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9496);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Container = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, _objectSpread({
        w: "full",
        pb: "12",
        pt: "3",
        maxW: {
            base: "xl",
            md: "7xl"
        },
        mx: "auto",
        px: {
            base: "6",
            md: "8"
        }
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SY": function() { return /* binding */ FooterLink; },
/* harmony export */   "dk": function() { return /* binding */ footerLinks; }
/* harmony export */ });
/* unused harmony export Footer */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9034);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7418);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9496);
/* harmony import */ var react_icons_bi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9950);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(405);
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4292);
/* harmony import */ var _components_svgs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1762);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7925);
/* harmony import */ var _container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4093);









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var FooterLink = function(param) {
    var href = param.href, // OPTIONAL
    icon = param.icon, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? "1.75rem" : _fontSize, _label = param.label, label = _label === void 0 ? href : _label;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, {
        display: "inline-block",
        href: href,
        "aria-label": label,
        isExternal: true,
        _hover: {
            color: "brand.500"
        },
        children: icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
            as: icon,
            fontSize: fontSize
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: label
        })
    });
};
var footerLinks = [
    {
        icon: react_icons_bi__WEBPACK_IMPORTED_MODULE_7__/* .BiPhone */ .kq7,
        label: "Phone",
        href: "tel:" + (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.phoneNum")
    },
    {
        icon: react_icons_hi__WEBPACK_IMPORTED_MODULE_8__/* .HiOutlineMail */ .Zuw,
        label: "Email",
        href: "mailto:" + (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.contactEmail")
    },
    {
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_9__/* .RiKakaoTalkLine */ .nyh,
        label: "Kakaotalk",
        href: (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.linkToKakaotalk")
    },
    {
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_9__/* .RiInstagramLine */ .Adh,
        label: "Instagram",
        href: (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.linkToInstagram")
    },
    {
        icon: _components_svgs__WEBPACK_IMPORTED_MODULE_2__/* .NaverLogoIcon */ .td,
        label: "NaverBlog",
        href: (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.linkToNaverBlog")
    }, 
];
var Footer = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
        as: "footer",
        py: {
            base: 4,
            md: 8
        },
        bg: "gray.800",
        color: "white",
        fontSize: {
            base: "0.9rem",
            md: "1.05rem"
        },
        textAlign: "left",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            py: 8,
            maxW: "1640px",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, {
                alignItems: "flex-start",
                flexDir: {
                    base: "column",
                    md: "row"
                },
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Stack */ .Kq, {
                        align: "center",
                        direction: "row",
                        flex: "1 1 0",
                        justify: "center",
                        mb: "2rem",
                        spacing: "12px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svgs__WEBPACK_IMPORTED_MODULE_2__/* .BrandLogo */ .Oc, {
                            logoStyleType: "light",
                            svgProps: {
                                width: {
                                    base: "10rem",
                                    md: "15rem"
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .VStack */ .gC, {
                        alignItems: "flex-start",
                        color: "gray.500",
                        flex: "10 1 0",
                        lineHeight: "1.2",
                        ml: {
                            base: 0,
                            md: "3.5rem"
                        },
                        mb: {
                            base: 3,
                            md: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                                color: "white",
                                mb: {
                                    base: "1rem",
                                    md: "0.6rem"
                                },
                                fontSize: {
                                    base: "0.9rem",
                                    md: "1.1rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                                        as: "span",
                                        display: {
                                            base: "none",
                                            md: "inline"
                                        },
                                        children: (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.brandEN") + " - "
                                    }),
                                    "PROFESSIONAL DIGITAL MARKETING COMPANY"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                                children: [
                                    "(주)",
                                    (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.brandKO"),
                                    " ",
                                    "| 대표: ",
                                    (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.ceoName"),
                                    " ",
                                    "| Tel:",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                        href: "tel:".concat((0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.phoneNum")),
                                        label: (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.phoneNum")
                                    }),
                                    " ",
                                    "| E-mail:",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                        href: "mailto:".concat((0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.contactEmail")),
                                        label: (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.contactEmail")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                                children: [
                                    "주소: ",
                                    (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.address1"),
                                    " ",
                                    (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.address2")
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                                children: [
                                    "사업자등록번호: ",
                                    (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.registrationNum"),
                                    " ",
                                    "| 통신판매업신고증: ",
                                    (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.registrationNumMailOrder")
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                                children: [
                                    "개인정보관리책임자: ",
                                    (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.ceoName")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .VStack */ .gC, {
                        align: {
                            base: "center",
                            md: "flex-end"
                        },
                        color: "gray.500",
                        fontSize: {
                            base: "0.9rem",
                            md: "1.1rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                                lineHeight: "1.2",
                                mb: {
                                    base: 6,
                                    md: "0.2rem"
                                },
                                children: [
                                    "Copyrights \xa9 2021 ",
                                    (0,_utils__WEBPACK_IMPORTED_MODULE_3__.t)("company.brandEN"),
                                    ". All rights reserved."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Stack */ .Kq, {
                                align: "center",
                                direction: "row",
                                flex: "1 1 0",
                                justify: "center",
                                spacing: 3,
                                children: footerLinks.map(function(link) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, _objectSpread({}, link), link.href);
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Footer);


/***/ }),

/***/ 109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ NavLink; },
  "Z": function() { return /* reexport */ header; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+icons@1.1.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js
var chakra_ui_icons_esm = __webpack_require__(2303);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@1.7.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(9034);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+color-mode@1.4.6_react@17.0.2/node_modules/@chakra-ui/color-mode/dist/chakra-ui-color-mode.esm.js
var chakra_ui_color_mode_esm = __webpack_require__(9262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@1.8.5_react@17.0.2/node_modules/@chakra-ui/hooks/dist/chakra-ui-hooks.esm.js
var chakra_ui_hooks_esm = __webpack_require__(8252);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+system@1.11.2_@emotion+react@11.8.1_@emotion+styled@11.8.1_react@17.0.2/node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 3 modules
var chakra_ui_system_esm = __webpack_require__(3879);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+button@1.5.8_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js + 2 modules
var chakra_ui_button_esm = __webpack_require__(9563);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+transition@1.4.7_framer-motion@6.2.8_react@17.0.2/node_modules/@chakra-ui/transition/dist/chakra-ui-transition.esm.js
var chakra_ui_transition_esm = __webpack_require__(8390);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_@babel+core@7.17.5_react-dom@17.0.2_react@17.0.2_sass@1.49.9/node_modules/next/dist/client/router.js
var router = __webpack_require__(9048);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_@babel+core@7.17.5_react-dom@17.0.2_react@17.0.2_sass@1.49.9/node_modules/next/link.js
var next_link = __webpack_require__(2343);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
;// CONCATENATED MODULE: ./src/components/logo.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Logo = function(props) {
    // const fill = useColorModeValue(`#2D3748`, `#fff`);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.svg */.m$.svg, _objectSpread({
        marginTop: "1.25rem",
        height: "3rem",
        width: "auto",
        viewBox: "0 0 998 257",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "g10",
            // inkscape:groupmode="layer"
            // inkscape:label="logo"
            transform: "matrix(1.3333333,0,0,-1.3333333,0,133.0032)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "g12",
                    transform: "translate(6.0687,99.7524)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "path14",
                        d: "m 0,0 -6.069,-4.454 v -6.094 L 0,-6.094 6.068,-10.548 v 6.094 z",
                        style: {
                            fill: "#00a1e9",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "g16",
                    transform: "translate(0,82.494)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "path18",
                        d: "m 0,0 v -6.094 l 6.069,4.454 6.068,-4.454 V 0 L 6.069,4.454 Z",
                        style: {
                            fill: "#0b3190",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "g20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        id: "g22",
                        clipPath: "url(#clipPath26)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g28",
                                transform: "translate(241.2803,44.8486)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path30",
                                    d: "M 0,0 C 0,18.039 14.675,32.713 32.71,32.713 50.749,32.713 65.423,18.039 65.423,0 V -2.207 H 77.56 V 0 c 0,24.729 -20.121,44.849 -44.85,44.849 -24.729,0 -44.846,-20.12 -44.846,-44.849 0,-24.729 20.117,-44.849 44.846,-44.849 h 2.207 v 12.137 H 32.71 C 14.675,-32.712 0,-18.038 0,0",
                                    style: {
                                        fill: "#181c62",
                                        fillOpacity: 1,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g32",
                                transform: "translate(313.1636,89.6977)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path34",
                                    d: "M 0,0 H -2.206 V -12.136 H 0 c 18.039,0 32.713,-14.675 32.713,-32.713 0,-18.038 -14.674,-32.713 -32.713,-32.713 -18.036,0 -32.71,14.675 -32.71,32.713 v 2.206 h -12.136 v -2.206 c 0,-24.729 20.117,-44.849 44.846,-44.849 24.729,0 44.849,20.12 44.849,44.849 C 44.849,-20.12 24.729,0 0,0",
                                    style: {
                                        fill: "#00a1e9",
                                        fillOpacity: 1,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g36",
                                transform: "translate(6.0684,74.144)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path38",
                                    d: "M 0,0 -6.068,-4.454 V -71.225 H 6.068 v 66.771 z",
                                    style: {
                                        fill: "#181c62",
                                        fillOpacity: 1,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g40",
                                transform: "translate(98.8389,21.6626)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path42",
                                    d: "m 0,0 -55.235,65.115 h -12.154 v -83.858 l 12.137,0.005 v 65.113 l 55.23,-65.113 6.092,-0.005 6.066,0.005 V 65.115 H 0 Z",
                                    style: {
                                        fill: "#181c62",
                                        fillOpacity: 1,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g44",
                                transform: "translate(398.7329,65.5913)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path46",
                                    d: "m 0,0 c -0.78,0.819 -1.446,1.748 -1.98,2.758 l -0.002,0.005 c -0.223,0.415 -0.485,1.206 -0.485,2.622 0,1.278 0.279,2.357 0.885,3.403 0.586,1.014 1.343,1.754 2.379,2.329 1.086,0.601 2.245,0.894 3.545,0.894 1.345,0 2.506,-0.286 3.551,-0.872 1.024,-0.578 1.775,-1.324 2.368,-2.349 0.608,-1.052 0.89,-2.134 0.89,-3.405 0,-2.204 -0.698,-3.728 -2.217,-5.006 L 3.331,-3.704 Z m -7.068,-26.877 8.732,6.878 21.966,-24.419 c -2.237,-2.98 -5.081,-5.372 -8.475,-7.126 -3.213,-1.655 -6.542,-1.868 -9.083,-1.868 -3.409,0 -6.611,0.758 -9.52,2.254 -2.877,1.476 -5.071,3.396 -6.708,5.863 -1.541,2.325 -2.291,4.771 -2.291,7.478 0,2.049 0.455,3.98 1.39,5.901 0.946,1.942 2.3,3.646 3.989,5.039 m 49.266,3.288 0.134,2.332 H 30.185 l -0.125,-2.074 c -0.153,-2.505 -0.423,-5.585 -1.125,-8.838 l -17.443,19.393 4.822,3.51 0.427,0.36 c 4.281,3.646 6.546,8.587 6.546,14.291 0,3.392 -0.847,6.581 -2.519,9.479 -1.683,2.905 -4.012,5.211 -6.923,6.85 -5.721,3.213 -13.149,3.215 -18.93,0.017 -2.961,-1.641 -5.317,-3.951 -7.002,-6.869 -1.67,-2.883 -2.517,-6.072 -2.517,-9.477 0,-3.148 0.641,-5.945 1.901,-8.311 1.034,-1.957 2.362,-3.81 3.795,-5.314 l 2.443,-2.718 -8.216,-6.466 c -3.12,-2.569 -5.572,-5.657 -7.288,-9.18 -1.735,-3.562 -2.614,-7.335 -2.614,-11.213 0,-5.103 1.453,-9.876 4.314,-14.186 2.776,-4.185 6.568,-7.531 11.274,-9.951 4.64,-2.385 9.708,-3.594 15.067,-3.594 3.168,0 7.973,0.258 13.099,2.504 l 1.321,0.58 v 0.025 c 0.076,0.035 0.151,0.074 0.227,0.112 4.342,2.239 8.08,5.176 11.145,8.753 l 8.421,-9.361 h 16.32 l -18.219,20.258 c 3.174,7.917 3.618,15.673 3.812,19.088",
                                    style: {
                                        fill: "#181c62",
                                        fillOpacity: 1,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g48",
                                transform: "translate(197.6772,21.6626)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path50",
                                    d: "m 0,0 -55.235,65.115 h -12.154 v -83.858 l 12.137,0.005 v 65.113 l 55.231,-65.113 6.091,-0.005 6.066,0.005 V 65.115 H 0 Z",
                                    style: {
                                        fill: "#181c62",
                                        fillOpacity: 1,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "g52",
                                transform: "translate(550.7549,86.7778)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "path54",
                                    d: "M 0,0 -35.835,-68.554 -71.67,0 h -11.762 v -83.858 h 12.137 v 56.946 l 29.767,-56.946 h 11.386 l 34.18,65.389 V -83.858 H 16.174 V 0 Z",
                                    style: {
                                        fill: "#181c62",
                                        fillOpacity: 1,
                                        fillRule: "nonzero",
                                        stroke: "none"
                                    }
                                })
                            })
                        ]
                    })
                })
            ]
        })
    })));
};
var LogoIcon = Logo;
/* harmony default export */ var logo = (Logo);

// EXTERNAL MODULE: ./src/layout/footer.tsx
var footer = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+popover@1.11.7_@chakra-ui+system@1.11.2_framer-motion@6.2.8_react@17.0.2/node_modules/@chakra-ui/popover/dist/chakra-ui-popover.esm.js + 55 modules
var chakra_ui_popover_esm = __webpack_require__(5897);
// EXTERNAL MODULE: ./configs/index.ts + 5 modules
var configs = __webpack_require__(9457);
// EXTERNAL MODULE: ./src/utils/index.ts + 10 modules
var utils = __webpack_require__(7925);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+icon@2.0.5_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/icon/dist/chakra-ui-icon.esm.js
var chakra_ui_icon_esm = __webpack_require__(7418);
;// CONCATENATED MODULE: ./src/layout/header/desktop-sub-nav.tsx



var DesktopSubNav = function(param) {
    var label = param.label, href = param.href, subLabel = param.subLabel;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
        href: href,
        role: "group",
        display: "block",
        p: 2,
        rounded: "md",
        _hover: {
            textDecoration: "none",
            color: "brand.500"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
            direction: "row",
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            _groupHover: {
                                color: "brand.500"
                            },
                            fontSize: "18px",
                            fontWeight: 500,
                            transitionProperty: "all",
                            transitionDuration: "faster",
                            transitionTimingFunction: "ease-in-out",
                            children: label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            fontSize: "sm",
                            children: subLabel
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                    transitionProperty: "all",
                    transitionDuration: "faster",
                    transitionTimingFunction: "ease-in-out",
                    opacity: 0,
                    _groupHover: {
                        opacity: "100%"
                    },
                    justify: "flex-end",
                    align: "center",
                    flex: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                        color: "brand.400",
                        w: 5,
                        h: 5,
                        as: chakra_ui_icons_esm/* ChevronRightIcon */.XC
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var desktop_sub_nav = (DesktopSubNav);

;// CONCATENATED MODULE: ./src/layout/header/desktop-nav.tsx






function desktop_nav_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function desktop_nav_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            desktop_nav_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var UNIT_NAME = "DesktopNav";
var log = (0,utils/* createLog */.xN)(UNIT_NAME);
var DesktopNav = function() {
    var pathname = (0,router.useRouter)().pathname;
    // const linkColor = useColorModeValue('gray.800', 'gray.200');
    var linkHoverColor = (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)("brand.500", "white");
    var popoverContentBgColor = (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)("white", "gray.800");
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Stack */.Kq, {
        direction: "row",
        spacing: "8rem",
        justifyContent: "flex-end",
        children: configs/* navItems.map */.te.map(function(navItem) {
            var ref;
            var isActive = (navItem === null || navItem === void 0 ? void 0 : (ref = navItem.href) === null || ref === void 0 ? void 0 : ref.includes("/business/")) && (pathname === null || pathname === void 0 ? void 0 : pathname.includes("/business/")) || pathname === (navItem === null || navItem === void 0 ? void 0 : navItem.href);
            log.debug("pathname: ".concat(pathname, ", navItem.href: ").concat(navItem === null || navItem === void 0 ? void 0 : navItem.href, ", isActive: ").concat(isActive));
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_popover_esm/* Popover */.J2, {
                    trigger: "hover",
                    placement: "bottom-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_popover_esm/* PopoverTrigger */.xo, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
                                color: isActive && linkHoverColor,
                                href: navItem.href,
                                p: 2,
                                textStyle: "body",
                                _hover: {
                                    textDecoration: "none",
                                    color: linkHoverColor
                                },
                                children: navItem.label
                            })
                        }),
                        navItem.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_popover_esm/* PopoverContent */.yk, {
                            // rounded='xl'
                            bg: popoverContentBgColor,
                            border: "none",
                            borderTop: "1px solid #eee",
                            boxShadow: "md",
                            minW: "100vw",
                            mt: "10px",
                            p: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* HStack */.Ug, {
                                borderTop: "1px solid gray.200",
                                justify: "flex-end",
                                mr: {
                                    'base': "18.3vw",
                                    '3xl': "29vw"
                                },
                                children: navItem.children.map(function(child) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(desktop_sub_nav, desktop_nav_objectSpread({}, child), child.label);
                                })
                            })
                        })
                    ]
                })
            }, navItem.label));
        })
    }));
};
/* harmony default export */ var desktop_nav = (DesktopNav);

;// CONCATENATED MODULE: ./src/layout/header/mobile-nav-item.tsx






var mobile_nav_item_log = (0,utils/* createLog */.xN)("MobileNavItem");
var MobileNavItem = function(param) {
    var label = param.label, children = param.children, href = param.href;
    var disableHref = href.includes("/business/");
    var pathname = (0,router.useRouter)().pathname;
    var ref = (0,chakra_ui_hooks_esm/* useDisclosure */.qY)(), isOpen = ref.isOpen, onToggle = ref.onToggle;
    var isActive = (0,react.useMemo)(function() {
        var isActiveLocal = (href === null || href === void 0 ? void 0 : href.includes("/business/")) && (pathname === null || pathname === void 0 ? void 0 : pathname.includes("/business/")) || pathname === href;
        mobile_nav_item_log.debug("isActive: ".concat(isActiveLocal, ", pathname: ").concat(pathname, ", href: ").concat(href));
        return isActiveLocal;
    }, [
        href,
        pathname
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
        spacing: 4,
        onClick: children && onToggle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                align: "center",
                as: chakra_ui_layout_esm/* Link */.rU,
                color: isActive && "brand.500",
                href: !disableHref ? href : undefined,
                justify: "space-between",
                py: 2,
                _hover: {
                    textDecoration: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        children: label
                    }),
                    children && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                        as: chakra_ui_icons_esm/* ChevronLeftIcon */.wy,
                        h: 6,
                        transform: isOpen ? "rotate(-90deg)" : "",
                        transitionDuration: "normal",
                        transitionProperty: "all",
                        transitionTimingFunction: "ease-in-out",
                        w: 6
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_transition_esm/* Collapse */.UO, {
                in: isOpen,
                animateOpacity: true,
                style: {
                    marginTop: "0 !important"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Stack */.Kq, {
                    mt: 2,
                    pl: 4,
                    borderLeft: 1,
                    borderStyle: "solid",
                    borderColor: (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)("gray.200", "gray.700"),
                    align: "start",
                    textStyle: "navbar-sub",
                    children: children && children.map(function(child) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
                            href: child.href,
                            py: 2,
                            w: "100%",
                            _hover: {
                                textDecoration: "none"
                            },
                            children: child.label
                        }, child.label);
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var mobile_nav_item = (MobileNavItem);

;// CONCATENATED MODULE: ./src/layout/header/mobile-nav.tsx





function mobile_nav_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_nav_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mobile_nav_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var MobileNav = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
        bg: (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)("white", "gray.800"),
        p: "1.5rem",
        pb: "2rem",
        // pb="100vh"
        display: {
            md: "none"
        },
        children: [
            configs/* navItems.map */.te.map(function(navItem) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(mobile_nav_item, mobile_nav_objectSpread({}, navItem), navItem.label);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Stack */.Kq, {
                align: "center",
                direction: "row",
                flex: {
                    base: 1,
                    md: 0
                },
                justify: "flex-end",
                mt: "2rem !important",
                opacity: "0.8",
                // position="absolute"
                // right="3rem"
                spacing: 3,
                children: footer/* footerLinks.map */.dk.map(function(link) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(footer/* FooterLink */.SY, mobile_nav_objectSpread({}, link), link.href);
                })
            })
        ]
    });
};
/* harmony default export */ var mobile_nav = (MobileNav);

;// CONCATENATED MODULE: ./src/layout/header/header.tsx










function header_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function header_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            header_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var NavLink = function(param) {
    var href = param.href, name = param.name, children = param.children;
    var pathname = (0,router.useRouter)().pathname;
    var isActive = pathname === href;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
        "aria-label": "".concat(name, " 페이지로 이동합니다"),
        color: isActive && "brand.500",
        display: "block",
        h: "7",
        href: href,
        transitionProperty: "color",
        transitionDuration: "normal",
        transitionTimingFunction: "ease-in-out",
        w: "25",
        _hover: {
            color: "brand.500"
        },
        children: children || name
    }));
};
var Header = function(props) {
    var bg = (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)("white", "gray.800");
    var ref = react.useRef();
    var ref1 = (0,chakra_ui_hooks_esm/* useDisclosure */.qY)(), isOpen = ref1.isOpen, onToggle = ref1.onToggle;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_system_esm/* chakra.header */.m$.header, header_objectSpread({
        bg: bg,
        left: "0",
        pos: "fixed",
        ref: ref,
        right: "0",
        shadow: "md",
        textStyle: "navbar",
        top: "0",
        transitionDuration: "normal",
        transitionProperty: "background-color, box-shadow",
        transitionTimingFunction: "ease-in-out",
        width: "full",
        zIndex: "3"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                align: "center",
                bg: (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)("white", "gray.800"),
                height: "4.75rem",
                justify: "space-between",
                maxW: "8xl",
                mx: "auto",
                px: {
                    base: "1.5rem"
                },
                py: {
                    base: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                        align: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_system_esm/* chakra.a */.m$.a, {
                                display: "block",
                                "aria-label": "INNONM, Back to homepage",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {
                                        display: {
                                            base: "none",
                                            md: "block"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                        minW: "3rem",
                                        display: {
                                            base: "block",
                                            md: "none"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoIcon, {})
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                        flex: {
                            base: 1,
                            md: "auto"
                        },
                        justify: "flex-end",
                        ml: {
                            base: -2
                        },
                        display: {
                            base: "flex",
                            md: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* IconButton */.hU, {
                            onClick: onToggle,
                            icon: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* CloseIcon */.Tw, {
                                w: "18px",
                                h: "18px"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* HamburgerIcon */.Uq, {
                                w: "28px",
                                h: "28px"
                            }),
                            variant: "ghost",
                            "aria-label": "Toggle Navigation"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Stack */.Kq, {
                        direction: "row",
                        display: {
                            base: "none",
                            md: "flex"
                        },
                        flex: {
                            base: 1,
                            md: 0
                        },
                        justify: "flex-end",
                        // mx="auto"
                        mr: "7vw",
                        spacing: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_nav, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Stack */.Kq, {
                        align: "center",
                        direction: "row",
                        display: {
                            base: "none",
                            md: "flex"
                        },
                        flex: {
                            base: 1,
                            md: 0
                        },
                        justify: "flex-end",
                        opacity: "0.8",
                        position: "absolute",
                        right: "3rem",
                        spacing: 3,
                        children: footer/* footerLinks.map */.dk.map(function(link) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(footer/* FooterLink */.SY, header_objectSpread({}, link), link.href);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_transition_esm/* Collapse */.UO, {
                in: isOpen,
                animateOpacity: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_nav, {})
            })
        ]
    })));
};
/* harmony default export */ var header = (Header);

;// CONCATENATED MODULE: ./src/layout/header/index.ts



/***/ }),

/***/ 7818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W2": function() { return /* reexport */ container/* default */.Z; },
  "IH": function() { return /* reexport */ content_section; },
  "$_": function() { return /* reexport */ footer/* default */.ZP; },
  "d": function() { return /* reexport */ section/* default */.ZP; },
  "h4": function() { return /* reexport */ header/* default */.Z; },
  "e5": function() { return /* reexport */ responsive_br; },
  "HJ": function() { return /* reexport */ seo; },
  "f3": function() { return /* reexport */ section/* SectionSize */.f3; },
  "bA": function() { return /* reexport */ section/* SectionType */.bA; }
});

// UNUSED EXPORTS: ContentSection2

// EXTERNAL MODULE: ./src/layout/container.tsx
var container = __webpack_require__(4093);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@1.7.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(9034);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+system@1.11.2_@emotion+react@11.8.1_@emotion+styled@11.8.1_react@17.0.2/node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 3 modules
var chakra_ui_system_esm = __webpack_require__(3879);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(9803);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-waypoint@10.1.0_react@17.0.2/node_modules/react-waypoint/es/index.js + 1 modules
var es = __webpack_require__(1285);
// EXTERNAL MODULE: ./configs/index.ts + 5 modules
var configs = __webpack_require__(9457);
// EXTERNAL MODULE: ./src/components/index.ts + 4 modules
var components = __webpack_require__(3890);
// EXTERNAL MODULE: ./src/utils/index.ts + 10 modules
var utils = __webpack_require__(7925);
// EXTERNAL MODULE: ./src/layout/content-section/content-section.module.scss
var content_section_module = __webpack_require__(1609);
var content_section_module_default = /*#__PURE__*/__webpack_require__.n(content_section_module);
;// CONCATENATED MODULE: ./src/layout/content-section/content-section.tsx










function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var log = (0,utils/* createLog */.xN)("ContentSection");
var ContentSection = function(param) {
    var children = param.children, // OPTIONAL
    handleEnter = param.handleEnter, handleLeave = param.handleLeave, subtitle = param.subtitle, title = param.title, _waypointBottomOffset = param.waypointBottomOffset, waypointBottomOffset = _waypointBottomOffset === void 0 ? "-30%" : _waypointBottomOffset, _waypointTopOffset = param.waypointTopOffset, waypointTopOffset = _waypointTopOffset === void 0 ? "5%" : _waypointTopOffset, // chakra-ui
    // bg,
    containerProps = param.containerProps, _isActive = param.// description,
    isActive, isActive = _isActive === void 0 ? true : _isActive, _maxW = param.maxW, maxW = _maxW === void 0 ? "1500px" : _maxW, _pb = param.pb, pb = _pb === void 0 ? {
        base: 24,
        md: 32
    } : _pb, _pt = param.pt, pt = _pt === void 0 ? {
        base: 24,
        md: 32
    } : _pt, _py = param.py, py = _py === void 0 ? {
        base: 24,
        md: 32
    } : _py, sectionProps = param.sectionProps, // title,
    titleTextUnderlineProps = param.titleTextUnderlineProps, // sectionProps
    id = param.id, // OPTIONAL
    className = param.className, bg = param.bg, bgColor = param.bgColor, _bgFixed = param.bgFixed, bgFixed = _bgFixed === void 0 ? false : _bgFixed, bgImg = param.bgImg, _bgDarken = param.bgDarken, bgDarken = _bgDarken === void 0 ? 0 : _bgDarken, _bgPos = param.bgPos, bgPos = _bgPos === void 0 ? "center center" : _bgPos, _bgRepeat = param.bgRepeat, bgRepeat = _bgRepeat === void 0 ? "no-repeat" : _bgRepeat, _bgSize = param.bgSize, bgSize = _bgSize === void 0 ? "cover" : _bgSize, color = param.color, contentTitle = param.contentTitle, _isCentered = param.isCentered, isCentered = _isCentered === void 0 ? false : _isCentered, _isFullHeight = param.isFullHeight, isFullHeight = _isFullHeight === void 0 ? false : _isFullHeight, _isFullWidth = param.isFullWidth, isFullWidth = _isFullWidth === void 0 ? false : _isFullWidth, _isOverflowVisible = param.isOverflowVisible, isOverflowVisible = _isOverflowVisible === void 0 ? false : _isOverflowVisible, sectionPaddingBottom = param.sectionPaddingBottom, sectionPaddingTop = param.sectionPaddingTop, sectionStyle = param.sectionStyle, _titleSeparator = param.titleSeparator, titleSeparator = _titleSeparator === void 0 ? "default" : _titleSeparator, titleStyle = param.titleStyle;
    var isMobile = (0,utils/* useGridProps */.by)().isMobile;
    var ref = _slicedToArray((0,utils/* useStateL */.Fs)(undefined, "titleColor"), 2), titleColor = ref[0], setTitleColor = ref[1];
    var ref1 = _slicedToArray((0,utils/* useStateL */.Fs)("brand.300", "underlineColor"), 2), underlineColor = ref1[0], _setUnderlineColor = ref1[1];
    (0,react.useEffect)(function() {
        if (bgColor === "dark" || bgImg) {
            setTitleColor("white");
        } else {
            setTitleColor("gray.700");
        }
    }, [
        bgColor,
        bgImg,
        setTitleColor
    ]);
    // useEffect(() => {
    //   if (titleSeparator === `dark`) {
    //     setUnderlineColor(`brand.300`);
    //   } else {
    //     setUnderlineColor(`brand.300`);
    //   }
    // }, [titleSeparator, setUnderlineColor]);
    var localSectionStyle = (0,react.useMemo)(function() {
        var style = {};
        style.background = "";
        if (bg) {
            style.background = bg;
        }
        // } else if (bgImg) {
        if (bgDarken > 0) {
            style.background = "linear-gradient(\n          to bottom,\n          rgba(23, 24, 32, ".concat(bgDarken, "),\n          rgba(23, 24, 32, ").concat(bgDarken, ")\n        ), ");
        }
        if (bgImg) style.background += "url('".concat(bgImg, "')");
        // style.background += `${bgRepeat} ${bgPos}`;
        style.backgroundSize = bgSize;
        style.backgroundPosition = bgPos;
        style.backgroundRepeat = bgRepeat;
        if (bgFixed) style.backgroundAttachment = "fixed";
        // }
        if (style.background === "") delete style.background;
        return style;
    }, [
        bg,
        bgImg,
        bgDarken,
        bgRepeat,
        bgPos,
        bgSize,
        bgFixed
    ]);
    // const [isActiveLocal, setActiveLocal] = useStateL(isActive, `isActiveLocal`);
    // useEffect(() => {
    //   setActiveLocal(isActive);
    // }, [isActive, setActiveLocal]);
    var localHandleEnter = (0,react.useCallback)(function(args) {
        if (configs/* NODE_ENV */.lC !== configs/* NodeEnv.PROD */.$X.PROD) log.debug("=> ENTER '".concat(id, "'"));
        // if (isMobile) setActiveLocal(true);
        if (handleEnter) handleEnter(args);
    }, [
        handleEnter,
        id
    ]);
    var localHandleLeave = (0,react.useCallback)(function(args) {
        if (configs/* NODE_ENV */.lC !== configs/* NodeEnv.PROD */.$X.PROD) log.debug("   LEAVE '".concat(id, "' =>"));
        // if (isMobile) setActiveLocal(false);
        if (handleLeave) handleLeave(args);
    }, [
        handleLeave,
        id
    ]);
    var _obj, _obj1;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, _objectSpread({
        as: "section",
        align: "center",
        justify: "center",
        id: id,
        bg: bg,
        py: py,
        pb: pb,
        pt: pt,
        mx: "auto"
    }, sectionProps, {
        className: classnames_default()(className, (content_section_module_default()).contentSection, (_obj = {}, _defineProperty(_obj, (content_section_module_default()).bgDark, bgColor === "dark"), _defineProperty(_obj, (content_section_module_default()).bgGray, bgColor === "gray"), _defineProperty(_obj, (content_section_module_default()).bgPrimary, bgColor === "primary"), _defineProperty(_obj, (content_section_module_default()).bgSecondary, bgColor === "secondary"), _defineProperty(_obj, (content_section_module_default()).colorLight, color === "light"), _defineProperty(_obj, (content_section_module_default()).isCentered, isCentered), _defineProperty(_obj, (content_section_module_default()).isFullHeight, isFullHeight && !isMobile), _obj)),
        style: _objectSpread({}, localSectionStyle, {
            paddingBottom: sectionPaddingBottom,
            paddingTop: sectionPaddingTop
        }, sectionStyle),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Waypoint */.h, {
            bottomOffset: waypointBottomOffset,
            onEnter: localHandleEnter,
            onLeave: localHandleLeave,
            topOffset: waypointTopOffset,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_system_esm/* chakra.div */.m$.div, _objectSpread({
                maxW: maxW,
                py: py,
                pb: pb,
                pt: pt
            }, containerProps, {
                children: [
                    title || subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                        maxW: "760px",
                        mx: "auto",
                        textAlign: "center",
                        mb: 14,
                        className: (content_section_module_default()).titleWrap,
                        style: _objectSpread({}, titleStyle),
                        children: [
                            title && // <FloatingItem id={`${id}Title`} delay={320} toggle={isActiveLocal}>
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.h2 */.m$.h2, {
                                textStyle: "heading",
                                mb: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextUnderlineDivider */.pX, _objectSpread({
                                    colorLight: titleColor,
                                    hide: titleSeparator === "none",
                                    show: titleSeparator !== "none",
                                    underlineColorLight: underlineColor
                                }, titleTextUnderlineProps, {
                                    children: title
                                }))
                            }),
                            subtitle && // <FloatingItem
                            //   id={`${id}Subtitle`}
                            //   className={styles.subtitle}
                            //   delay={360}
                            //   toggle={isActiveLocal}
                            // >
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.p */.m$.p, {
                                textStyle: "description",
                                children: subtitle
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((content_section_module_default()).content, (_obj1 = {}, _defineProperty(_obj1, (content_section_module_default()).isFullWidth, isFullWidth), _defineProperty(_obj1, (content_section_module_default()).overflowVisible, isOverflowVisible), _obj1)),
                        children: [
                            contentTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                                className: (content_section_module_default()).contentTitle,
                                children: contentTitle
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                                py: 3,
                                className: (content_section_module_default()).contentBody,
                                children: children
                            })
                        ]
                    })
                ]
            }))
        })
    })));
};
/* harmony default export */ var content_section = (ContentSection);

// EXTERNAL MODULE: ./node_modules/.pnpm/@react-spring+web@9.4.3_react-dom@17.0.2_react@17.0.2/node_modules/@react-spring/web/dist/react-spring-web.esm.js
var react_spring_web_esm = __webpack_require__(6249);
;// CONCATENATED MODULE: ./src/components/react-spring/AnimatedPath.tsx



function AnimatedPath_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AnimatedPath_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AnimatedPath_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AnimatedPath = function(param) {
    var // OPTIONAL
    pathProps = param.pathProps, _delay = param.// react-spring
    // OPTIONAL
    delay, delay = _delay === void 0 ? 250 : _delay, _toggleFill = param.toggleFill, toggleFill = _toggleFill === void 0 ? false : _toggleFill, varFill1 = param.varFill1, varFill2 = param.varFill2;
    var animationFillStyle = useSpring({
        fill: toggleFill ? varFill2 : varFill1,
        delay: delay
    });
    return(/*#__PURE__*/ _jsx(animated.path, AnimatedPath_objectSpread({}, pathProps, {
        style: animationFillStyle
    })));
};
/* harmony default export */ var react_spring_AnimatedPath = ((/* unused pure expression or super */ null && (AnimatedPath)));

;// CONCATENATED MODULE: ./src/components/react-spring/AnimatedSvg.tsx



function AnimatedSvg_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AnimatedSvg_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AnimatedSvg_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AnimatedSvg = function(param) {
    var // REQUIRED
    children = param.children, _style = param.// OPTIONAL
    style, style = _style === void 0 ? {} : _style, // svgProps
    // OPTIONAL
    svgProps = param.svgProps, varOpacity = param.varOpacity;
    return(/*#__PURE__*/ _jsx(animated.svg, AnimatedSvg_objectSpread({}, svgProps, {
        style: AnimatedSvg_objectSpread({}, style, {
            opacity: varOpacity ? varOpacity.to({
                range: [
                    0,
                    1
                ],
                output: [
                    0,
                    1
                ]
            }) : 1
        }),
        children: children
    })));
};
/* harmony default export */ var react_spring_AnimatedSvg = ((/* unused pure expression or super */ null && (AnimatedSvg)));

;// CONCATENATED MODULE: ./src/components/react-spring/Floating.tsx



var Floating_Floating = function(param) {
    var // REQUIRED
    children = param.children, open = param.open, _delay = param.// OPTIONAL
    // onClick,
    delay, delay = _delay === void 0 ? 0 : _delay, _duration = param.duration, duration = _duration === void 0 ? 300 : _duration;
    var spring = useSpring({
        config: {
            mass: 5,
            tension: 2000,
            friction: 200,
            duration: duration
        },
        from: {
            opacity: 0,
            transform: "translateY(50px)"
        },
        to: {
            opacity: open ? 1 : 0,
            transform: open ? "translateY(0)" : "translateY(50px)"
        },
        delay: delay
    });
    return(/*#__PURE__*/ _jsx(animated.div, {
        style: spring,
        children: children
    }));
};
/* harmony default export */ var react_spring_Floating = ((/* unused pure expression or super */ null && (Floating_Floating)));

;// CONCATENATED MODULE: ./src/components/react-spring/SvgHoverTransition.tsx




function SvgHoverTransition_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SvgHoverTransition_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function SvgHoverTransition_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SvgHoverTransition_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SvgHoverTransition_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SvgHoverTransition_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SvgHoverTransition_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SvgHoverTransition_slicedToArray(arr, i) {
    return SvgHoverTransition_arrayWithHoles(arr) || SvgHoverTransition_iterableToArrayLimit(arr, i) || SvgHoverTransition_unsupportedIterableToArray(arr, i) || SvgHoverTransition_nonIterableRest();
}
function SvgHoverTransition_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SvgHoverTransition_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SvgHoverTransition_arrayLikeToArray(o, minLen);
}
var SvgHoverTransition_log = (0,utils/* createLog */.xN)("SvgHoverTransition");
var SvgHoverTransition = function(param1) {
    var // REQUIRED
    Svg1 = param1.Svg1, Svg2 = param1.Svg2, toggle = param1.toggle, _autoToggle = param1.// OPTIONAL
    autoToggle, autoToggle = _autoToggle === void 0 ? false : _autoToggle, _autoToggleDelay = param1.autoToggleDelay, autoToggleDelay = _autoToggleDelay === void 0 ? 200 : _autoToggleDelay, _autoToggleDuration = param1.autoToggleDuration, autoToggleDuration = _autoToggleDuration === void 0 ? 1000 : _autoToggleDuration, _springProps = param1.springProps, springProps = _springProps === void 0 ? {
        from: {
            position: "absolute",
            opacity: 0
        },
        enter: {
            opacity: 1
        },
        leave: {
            opacity: 0
        },
        delay: 100,
        config: config.molasses
    } : _springProps, _style = param1.style, style = _style === void 0 ? {} : _style;
    var ref = SvgHoverTransition_slicedToArray(useStateL(toggle, "localToggle"), 2), localToggle = ref[0], setLocalToggle = ref[1];
    useEffect(function() {
        setLocalToggle(toggle);
    }, [
        setLocalToggle,
        toggle
    ]);
    useEffect(function() {
        if (autoToggle) {
            SvgHoverTransition_log.debug("autoToggle");
            var timeout1 = setTimeout(function() {
                SvgHoverTransition_log.debug("timeout1");
                setLocalToggle(true);
            }, autoToggleDelay);
            var timeout2 = setTimeout(function() {
                SvgHoverTransition_log.debug("timeout2");
                setLocalToggle(false);
            }, autoToggleDelay + autoToggleDuration);
            return function() {
                clearTimeout(timeout1);
                clearTimeout(timeout2);
            };
        }
        return function() {
            return null;
        };
    }, [
        autoToggle,
        autoToggleDelay,
        autoToggleDuration,
        setLocalToggle
    ]);
    var transitions = useTransition(localToggle, springProps);
    return(/*#__PURE__*/ _jsx(_Fragment, {
        children: transitions(function(param, toggleItem) {
            var opacity = param.opacity;
            var svgProps = {
                opacity: opacity,
                style: style
            };
            return toggleItem ? /*#__PURE__*/ _jsx(Svg2, SvgHoverTransition_objectSpread({}, svgProps)) : /*#__PURE__*/ _jsx(Svg1, SvgHoverTransition_objectSpread({}, svgProps));
        })
    }));
};
/* harmony default export */ var react_spring_SvgHoverTransition = ((/* unused pure expression or super */ null && (SvgHoverTransition)));

;// CONCATENATED MODULE: ./src/components/react-spring/SvgTransition.tsx



function SvgTransition_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SvgTransition_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SvgTransition_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SvgTransition = function(param1) {
    var // REQUIRED
    id = param1.id, Svg1 = param1.Svg1, Svg2 = param1.Svg2, toggle = param1.toggle, // OPTIONAL
    className = param1.className, _springProps = param1.springProps, springProps = _springProps === void 0 ? {
        from: {
            position: "absolute",
            opacity: 0
        },
        enter: {
            opacity: 1
        },
        leave: {
            opacity: 0
        },
        delay: 100,
        config: config.molasses
    } : _springProps, _style = param1.style, style = _style === void 0 ? {} : _style;
    var transitions = useTransition(toggle, springProps);
    return(/*#__PURE__*/ _jsx(_Fragment, {
        children: transitions(function(param, alt) {
            var opacity = param.opacity;
            var svgProps = {
                id: alt ? "".concat(id, "Alt") : id,
                className: className,
                varOpacity: opacity,
                style: style
            };
            return alt ? /*#__PURE__*/ _jsx(Svg2, SvgTransition_objectSpread({}, svgProps)) : /*#__PURE__*/ _jsx(Svg1, SvgTransition_objectSpread({}, svgProps));
        })
    }));
};
/* harmony default export */ var react_spring_SvgTransition = ((/* unused pure expression or super */ null && (SvgTransition)));

;// CONCATENATED MODULE: ./src/components/react-spring/Trail.tsx





function Trail_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Trail_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Trail_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Trail = function(param) {
    var // REQUIRED
    id = param.id, elements = param.elements, open = param.open, _defaultStyle = param.// OPTIONAL
    defaultStyle, defaultStyle = _defaultStyle === void 0 ? false : _defaultStyle, _delay = param.delay, delay = _delay === void 0 ? 0 : _delay, _duration = param.duration, duration = _duration === void 0 ? 250 : _duration;
    var wrapProps = {
        id: id,
        elements: elements,
        open: open,
        delay: delay,
        duration: duration
    };
    // TODO: when elements are string convert them to Array<JSX.Element>
    // function createTrailItems(rawData: Array<string>): any {
    //   return rawData.map((item) => <span>{item}</span>);
    // }
    // const items = useMemo(() => createTrailItems(data), [data]);
    // const [items, setItems] = useStateL(createTrailItems(data), `items`);
    var trail = useTrail(elements.length, {
        config: {
            mass: 5,
            tension: 2000,
            friction: 200,
            duration: duration
        },
        from: {
            opacity: 0,
            x: 20,
            height: 0
        },
        to: {
            opacity: open ? 1 : 0,
            x: open ? 0 : 20,
            height: open ? 110 : 0
        },
        delay: delay
    });
    return(/*#__PURE__*/ _jsx("div", Trail_objectSpread({
        className: cn(defaultStyle ? styles.defaultTrailsMain : styles.trailsMain)
    }, wrapProps, {
        children: /*#__PURE__*/ _jsx("div", {
            children: trail.map(function(_param, index) /*#__PURE__*/ {
                var x = _param.x, height = _param.height, style = _objectWithoutProperties(_param, [
                    "x",
                    "height"
                ]);
                return _jsx(animated.div, {
                    className: "".concat(defaultStyle ? styles.defaultTrailsText : styles.trailsText),
                    style: Trail_objectSpread({}, style, {
                        transform: x.to(function(x2) {
                            return "translate3d(0,".concat(x2, "px,0)");
                        })
                    }),
                    children: /*#__PURE__*/ _jsx(animated.div, {
                        style: {
                            height: height
                        },
                        children: elements[index]
                    })
                }, "".concat(id, "-").concat(index));
            })
        })
    })));
};
/* harmony default export */ var react_spring_Trail = ((/* unused pure expression or super */ null && (Trail)));

;// CONCATENATED MODULE: ./src/components/react-spring/index.ts







;// CONCATENATED MODULE: ./src/components/animation/floating-item.tsx




function floating_item_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function floating_item_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function floating_item_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function floating_item_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function floating_item_slicedToArray(arr, i) {
    return floating_item_arrayWithHoles(arr) || floating_item_iterableToArrayLimit(arr, i) || floating_item_unsupportedIterableToArray(arr, i) || floating_item_nonIterableRest();
}
function floating_item_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return floating_item_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return floating_item_arrayLikeToArray(o, minLen);
}
var floating_item_FloatingItem = function(param) {
    var // REQUIRED
    children = param.children, toggle = param.toggle, // OPTIONAL
    // handleEnter,
    // handleLeave,
    // idx,
    // offsetBottom = `0px`,
    // offsetTop = `0px`,
    // onClick,
    id = param.id, className = param.className, _delay = param.delay, delay = _delay === void 0 ? 300 : _delay, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _duration = param.duration, duration = _duration === void 0 ? 300 : _duration;
    // const [toggle, setToggle] = useStateL(false, `toggle`);
    // useEffect(() => {
    //   if (isActive) setToggle(isActive);
    // }, [isActive, setToggle]);
    // const localHandleEnter = (args: Waypoint.CallbackArgs) => {
    //   log.debug(`<= ENTER FloatingItem '${id}'`);
    //   setToggle(true);
    //   if (handleEnter) handleEnter(idx, args);
    // };
    // const localHandleLeave = (args: Waypoint.CallbackArgs) => {
    //   log.debug(`=> LEAVE FloatingItem '${id}'`);
    //   setToggle(false);
    //   if (handleLeave) handleLeave(idx, args);
    // };
    var ref = floating_item_slicedToArray(useStateL(undefined, "toRender"), 2), toRender = ref[0], setToRender = ref[1];
    // TODO: restore waypoint feature
    useEffect(function() {
        setToRender(// <Waypoint
        //   key={id}
        //   onEnter={localHandleEnter}
        //   onLeave={localHandleLeave}
        //   topOffset={offsetTop}
        //   bottomOffset={offsetBottom}
        // >
        /*#__PURE__*/ _jsx("div", {
            id: id,
            className: className,
            children: disabled ? children : /*#__PURE__*/ _jsx(Floating, {
                open: toggle,
                delay: delay,
                duration: duration,
                children: children
            })
        }));
    }, [
        children,
        className,
        delay,
        disabled,
        duration,
        id,
        setToRender,
        toggle
    ]);
    return(/*#__PURE__*/ _jsx(_Fragment, {
        children: toRender
    }));
};
/* harmony default export */ var floating_item = ((/* unused pure expression or super */ null && (floating_item_FloatingItem)));

;// CONCATENATED MODULE: ./src/components/animation/floating-trails.tsx





function floating_trails_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function floating_trails_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function floating_trails_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function floating_trails_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function floating_trails_slicedToArray(arr, i) {
    return floating_trails_arrayWithHoles(arr) || floating_trails_iterableToArrayLimit(arr, i) || floating_trails_unsupportedIterableToArray(arr, i) || floating_trails_nonIterableRest();
}
function floating_trails_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return floating_trails_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return floating_trails_arrayLikeToArray(o, minLen);
}
var floating_trails_log = (0,utils/* createLog */.xN)("FloatingTrails");
var FloatingTrails = function(param) {
    var id = param.id, children = param.children;
    var ref = floating_trails_slicedToArray(useStateL({
        toggle: false
    }, "toggle"), 2), setToggle = ref[1];
    var onEnter = function() {
        if (NODE_ENV !== NodeEnv.PROD) {
            floating_trails_log.debug("enter trails '".concat(id, "'"));
        }
        setToggle({
            toggle: true
        });
    };
    var onLeave = function() {
        if (NODE_ENV !== NodeEnv.PROD) {
            floating_trails_log.debug("leave trails '".concat(id, "'"));
        }
        setToggle({
            toggle: false
        });
    };
    return(/*#__PURE__*/ _jsx(Waypoint, {
        onEnter: onEnter,
        onLeave: onLeave,
        children: children
    }, id));
};
/* harmony default export */ var floating_trails = ((/* unused pure expression or super */ null && (FloatingTrails)));

;// CONCATENATED MODULE: ./src/components/animation/index.ts



;// CONCATENATED MODULE: ./src/contexts/app-context.tsx
/* provided dependency */ var process = __webpack_require__(4248);

// TODO: add KakaoMapPropsContext
var getAppContextValue = function() {
    return {
        brandEN: process.env.NEXT_PUBLIC_BRAND_EN || "INNO&M",
        brandKO: process.env.NEXT_PUBLIC_BRAND_KO || "이노앤엠",
        disableMap: process.env.NEXT_PUBLIC_DISABLE_MAP === "true",
        kakaoMapApiKey: "807c663f23e4cc79cec3f709ca216c65" || 0
    };
};
var app_context_AppContext = /*#__PURE__*/ react.createContext(getAppContextValue());

;// CONCATENATED MODULE: ./src/contexts/index.ts


;// CONCATENATED MODULE: ./src/layout/content-section-2/ContentSection.tsx










function ContentSection_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ContentSection_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ContentSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ContentSection_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ContentSection_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ContentSection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ContentSection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ContentSection_slicedToArray(arr, i) {
    return ContentSection_arrayWithHoles(arr) || ContentSection_iterableToArrayLimit(arr, i) || ContentSection_unsupportedIterableToArray(arr, i) || ContentSection_nonIterableRest();
}
function ContentSection_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ContentSection_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ContentSection_arrayLikeToArray(o, minLen);
}
var ContentSection_log = (0,utils/* createLog */.xN)("ContentSection");
var ContentSection_ContentSection = function(param) {
    var children = param.children, // OPTIONAL
    handleEnter = param.handleEnter, handleLeave = param.handleLeave, subtitle = param.subtitle, title = param.title, _waypointBottomOffset = param.// waypointBottomOffset = -19.5,
    // waypointTopOffset = 10,
    waypointBottomOffset, waypointBottomOffset = _waypointBottomOffset === void 0 ? "-30%" : _waypointBottomOffset, _waypointTopOffset = param.waypointTopOffset, waypointTopOffset = _waypointTopOffset === void 0 ? "5%" : _waypointTopOffset, // waypointBottomOffset = -200,
    // waypointTopOffset = -100,
    // sectionProps
    id = param.id, // OPTIONAL
    className = param.className, bg = param.bg, bgColor = param.bgColor, _bgFixed = param.bgFixed, bgFixed = _bgFixed === void 0 ? false : _bgFixed, bgImg = param.bgImg, _bgDarken = param.bgDarken, bgDarken = _bgDarken === void 0 ? 0 : _bgDarken, bgPos = param.bgPos, color = param.color, contentTitle = param.contentTitle, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, _isCentered = param.isCentered, isCentered = _isCentered === void 0 ? false : _isCentered, _isFullHeight = param.isFullHeight, isFullHeight = _isFullHeight === void 0 ? false : _isFullHeight, _isFullWidth = param.isFullWidth, isFullWidth = _isFullWidth === void 0 ? false : _isFullWidth, _isOverflowVisible = param.isOverflowVisible, isOverflowVisible = _isOverflowVisible === void 0 ? false : _isOverflowVisible, sectionPaddingBottom = param.sectionPaddingBottom, sectionPaddingTop = param.sectionPaddingTop, sectionStyle = param.sectionStyle, _titleSeparator = param.titleSeparator, titleSeparator = _titleSeparator === void 0 ? "default" : _titleSeparator, titleStyle = param.titleStyle;
    var brandEN = useContext(AppContext).brandEN;
    var isMobile = useGridProps().isMobile;
    var localSectionStyle = useMemo(function() {
        var style = {};
        style.background = "";
        if (bg) {
            style.background = bg;
        } else if (bgDarken > 0) {
            style.background = "linear-gradient(\n          to bottom,\n          rgba(23, 24, 32, ".concat(bgDarken, "),\n          rgba(23, 24, 32, ").concat(bgDarken, ")\n        ), ");
        }
        if (bgImg) {
            style.background += "url('".concat(bgImg, "') no-repeat");
            style.backgroundSize = "cover";
        }
        if (bgFixed) style.backgroundAttachment = "fixed";
        if (bgPos) style.backgroundPosition = bgPos;
        return style;
    }, [
        bg,
        bgFixed,
        bgImg,
        bgDarken,
        bgPos
    ]);
    var ref = ContentSection_slicedToArray(useStateL(isActive, "isActiveLocal"), 2), isActiveLocal = ref[0], setActiveLocal = ref[1];
    useEffect(function() {
        setActiveLocal(isActive);
    }, [
        isActive,
        setActiveLocal
    ]);
    var localHandleEnter = useCallback(function(args) {
        if (NODE_ENV !== NodeEnv.PROD) ContentSection_log.debug("=> ENTER '".concat(id, "'"));
        if (isMobile) setActiveLocal(true);
        if (handleEnter) handleEnter(args);
    }, [
        handleEnter,
        id,
        isMobile,
        setActiveLocal
    ]);
    var localHandleLeave = useCallback(function(args) {
        if (NODE_ENV !== NodeEnv.PROD) ContentSection_log.debug("   LEAVE '".concat(id, "' =>"));
        if (isMobile) setActiveLocal(false);
        if (handleLeave) handleLeave(args);
    }, [
        handleLeave,
        id,
        isMobile,
        setActiveLocal
    ]);
    var _obj, _obj1, _obj2;
    return(/*#__PURE__*/ _jsx("section", {
        id: id,
        className: cn(className, styles.contentSection, (_obj = {}, ContentSection_defineProperty(_obj, styles.bgDark, bgColor === "dark"), ContentSection_defineProperty(_obj, styles.bgGray, bgColor === "gray"), ContentSection_defineProperty(_obj, styles.bgPrimary, bgColor === "primary"), ContentSection_defineProperty(_obj, styles.bgSecondary, bgColor === "secondary"), ContentSection_defineProperty(_obj, styles.colorLight, color === "light"), ContentSection_defineProperty(_obj, styles.isCentered, isCentered), ContentSection_defineProperty(_obj, styles.isFullHeight, isFullHeight && !isMobile), ContentSection_defineProperty(_obj, styles.isFullWidth, isFullWidth), _obj)),
        style: ContentSection_objectSpread({}, localSectionStyle, {
            paddingBottom: sectionPaddingBottom,
            paddingTop: sectionPaddingTop
        }, sectionStyle),
        children: /*#__PURE__*/ _jsx(Waypoint, {
            bottomOffset: waypointBottomOffset,
            onEnter: localHandleEnter,
            onLeave: localHandleLeave,
            topOffset: waypointTopOffset,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.contentWrap,
                children: [
                    title ? /*#__PURE__*/ _jsxs("div", {
                        className: cn(styles.titleWrap, (_obj1 = {}, ContentSection_defineProperty(_obj1, styles.titleSeparatorDefault, titleSeparator === "default"), ContentSection_defineProperty(_obj1, styles.titleSeparatorDark, titleSeparator === "dark"), ContentSection_defineProperty(_obj1, styles.titleSeparatorNone, titleSeparator === "none"), _obj1)),
                        style: ContentSection_objectSpread({}, titleStyle),
                        children: [
                            /*#__PURE__*/ _jsx(FloatingItem, {
                                id: "".concat(id, "Title"),
                                className: styles.title,
                                delay: 320,
                                toggle: isActiveLocal,
                                children: typeof title === "string" ? /*#__PURE__*/ _jsxs("h2", {
                                    children: [
                                        /*#__PURE__*/ _jsx("em", {
                                            children: title
                                        }),
                                        /*#__PURE__*/ _jsx("br", {
                                            className: "md"
                                        }),
                                        " OF ",
                                        brandEN
                                    ]
                                }) : /*#__PURE__*/ _jsx("h2", {
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ _jsx(FloatingItem, {
                                id: "".concat(id, "Subtitle"),
                                className: styles.subtitle,
                                delay: 360,
                                toggle: isActiveLocal,
                                children: /*#__PURE__*/ _jsx("h3", {
                                    children: subtitle
                                })
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsxs("div", {
                        className: cn(styles.content, (_obj2 = {}, ContentSection_defineProperty(_obj2, styles.isFullWidth, isFullWidth), ContentSection_defineProperty(_obj2, styles.overflowVisible, isOverflowVisible), _obj2)),
                        children: [
                            contentTitle ? /*#__PURE__*/ _jsx(Container, {
                                className: styles.contentTitle,
                                children: contentTitle
                            }) : null,
                            /*#__PURE__*/ _jsx(Container, {
                                className: styles.contentBody,
                                children: children
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var content_section_2_ContentSection = ((/* unused pure expression or super */ null && (ContentSection_ContentSection)));

// EXTERNAL MODULE: ./src/layout/footer.tsx
var footer = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/layout/section.tsx
var section = __webpack_require__(2179);
// EXTERNAL MODULE: ./src/layout/header/index.ts + 6 modules
var header = __webpack_require__(109);
;// CONCATENATED MODULE: ./src/layout/responsive-br.tsx


function responsive_br_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function responsive_br_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            responsive_br_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ResponsiveBr = function(param) {
    var breakpoint = param.breakpoint, // OPTIONAL
    brProps = param.brProps;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("br", responsive_br_objectSpread({
        className: breakpoint
    }, brProps));
};
/* harmony default export */ var responsive_br = (ResponsiveBr);

// EXTERNAL MODULE: ./node_modules/.pnpm/next-seo@4.29.0_next@12.1.0_react-dom@17.0.2_react@17.0.2/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(9354);
// EXTERNAL MODULE: ./configs/site-config.ts
var site_config = __webpack_require__(5560);
;// CONCATENATED MODULE: ./src/layout/seo.tsx




var SEO = function(param) {
    var title = param.title, description = param.description;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: title,
        description: description,
        openGraph: {
            title: title,
            description: description
        },
        titleTemplate: site_config/* default.seo.titleTemplate */.Z.seo.titleTemplate
    });
};
/* harmony default export */ var seo = (SEO);

;// CONCATENATED MODULE: ./src/layout/index.ts










/***/ }),

/***/ 2179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bA": function() { return /* binding */ SectionType; },
/* harmony export */   "f3": function() { return /* binding */ SectionSize; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9034);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9563);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3879);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1376);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9496);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2231);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(348);
/* harmony import */ var _configs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9457);
/* harmony import */ var _configs_motion_presets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4324);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3890);
/* harmony import */ var _components_chakra_ui_framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7994);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7925);











function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var UNIT_NAME = "GeneralSection";
var SectionType;
(function(SectionType) {
    SectionType["DARK"] = "dark";
    SectionType["GRAY"] = "gray";
    SectionType["LIGHT"] = "light";
    SectionType["WHITE"] = "white";
})(SectionType || (SectionType = {}));
var SectionSize;
(function(SectionSize) {
    SectionSize["FIT"] = "fit";
    SectionSize["XS"] = "xs";
    SectionSize["SM"] = "sm";
    SectionSize["MD"] = "md";
    SectionSize["LG"] = "lg";
    SectionSize["XL"] = "xl";
    SectionSize["XXL"] = "xxl";
})(SectionSize || (SectionSize = {}));
var GeneralSection = function(param) {
    var //
    // BaseSectionProps
    //
    children = param.children, name = param.name, // OPTIONAL
    id = param.id, className = param.className, bgProps = param.bgProps, _bgFixed = param.bgFixed, bgFixed = _bgFixed === void 0 ? false : _bgFixed, bgImg = param.bgImg, _bgDarken = param.bgDarken, bgDarken = _bgDarken === void 0 ? 0 : _bgDarken, _bgPos = param.bgPos, bgPos = _bgPos === void 0 ? "center center" : _bgPos, _bgRepeat = param.bgRepeat, bgRepeat = _bgRepeat === void 0 ? "no-repeat" : _bgRepeat, _bgSize = param.bgSize, bgSize = _bgSize === void 0 ? "cover" : _bgSize, _isCentered = param.isCentered, isCentered = _isCentered === void 0 ? false : _isCentered, _pbMult = param.pbMult, pbMult = _pbMult === void 0 ? 1.3 : _pbMult, _px = param.px, px = _px === void 0 ? {
        base: "0.75rem",
        md: "2rem"
    } : _px, sectionProps = param.sectionProps, _sectionSize = param.sectionSize, sectionSize = _sectionSize === void 0 ? SectionSize.MD : _sectionSize, _sectionType = param.sectionType, sectionType = _sectionType === void 0 ? SectionType.WHITE : _sectionType, //
    // GeneralSectionProps
    //
    // OPTIONAL
    containerProps = param.containerProps, _disableAnimation = param.disableAnimation, disableAnimation = _disableAnimation === void 0 ? false : _disableAnimation, _disableAnimationContents = param.disableAnimationContents, disableAnimationContents = _disableAnimationContents === void 0 ? false : _disableAnimationContents, _disableAnimationTitle = param.disableAnimationTitle, disableAnimationTitle = _disableAnimationTitle === void 0 ? false : _disableAnimationTitle, description = param.description, descriptionProps = param.descriptionProps, handleInView = param.handleInView, inViewOptions = param.inViewOptions, title = param.title, titleProps = param.titleProps, titleTextUnderlineDividerProps = param.titleTextUnderlineDividerProps, titleWrapProps = param.titleWrapProps;
    var isMobile = (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .useGridProps */ .by)().isMobile;
    var pascalName = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return _utils__WEBPACK_IMPORTED_MODULE_6__.__.pascalCase(name);
    }, [
        name
    ]);
    var log = (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .useLog */ .Tx)("".concat(UNIT_NAME, "/").concat(name));
    var ref = _slicedToArray((0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_7__/* .useInView */ .YD)(inViewOptions), 3), inViewRef = ref[0], inView = ref[1], inViewEntry = ref[2];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (handleInView) {
            // TODO: log not printing
            log.debug("inView: ".concat(inView, ", inViewEntry: ").concat(JSON.stringify(inViewEntry)));
            handleInView(inView, inViewEntry);
        }
    }, [
        handleInView,
        inView,
        inViewEntry,
        log,
        name
    ]);
    var ref1 = _slicedToArray((0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .useStateL */ .Fs)(undefined, "bg"), 2), bg = ref1[0], setBg = ref1[1];
    var ref2 = _slicedToArray((0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .useStateL */ .Fs)(undefined, "titleColor"), 2), titleColor = ref2[0], setTitleColor = ref2[1];
    var ref3 = _slicedToArray((0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .useStateL */ .Fs)(undefined, "underlineColor"), 2), underlineColor = ref3[0], setUnderlineColor = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setUnderlineColor("brand.300");
        switch(sectionType){
            case SectionType.DARK:
                setBg("gray.800");
                setTitleColor("white");
                break;
            case SectionType.GRAY:
                setBg("bg.gray");
                setTitleColor("gray.700");
                break;
            case SectionType.LIGHT:
                setBg("gray.50");
                setTitleColor("gray.700");
                break;
            case SectionType.WHITE:
                setBg("white");
                setTitleColor("gray.700");
                break;
            default:
                throw new Error("Unknown section type: ".concat(sectionType));
        }
    }, [
        sectionType,
        setBg,
        setTitleColor,
        setUnderlineColor
    ]);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ptLocal;
        // prettier-ignore
        switch(sectionSize){
            case SectionSize.FIT:
                ptLocal = {
                    base: 0,
                    md: 0
                };
                break;
            case SectionSize.XS:
                ptLocal = {
                    base: 4,
                    md: 4
                };
                break;
            case SectionSize.SM:
                ptLocal = {
                    base: 8,
                    md: 8
                };
                break;
            case SectionSize.MD:
                ptLocal = {
                    base: 14,
                    md: 14
                };
                break;
            case SectionSize.LG:
                ptLocal = {
                    base: 16,
                    md: 16
                };
                break;
            case SectionSize.XL:
                ptLocal = {
                    base: 20,
                    md: 20
                };
                break;
            case SectionSize.XXL:
                ptLocal = {
                    base: 24,
                    md: 24
                };
                break;
            default:
                throw new Error("Unknown section size: ".concat(sectionSize));
        }
        return {
            pt: ptLocal,
            pb: {
                base: "".concat(ptLocal.base * 4 * pbMult, "px"),
                md: "".concat(ptLocal.md * 4 * pbMult, "px")
            }
        };
    }, [
        pbMult,
        sectionSize
    ]), pt = ref4.pt, pb = ref4.pb;
    var sectionStyleLocal = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var style = {};
        style.background = "";
        if (bgImg) {
            if (bgDarken > 0) {
                style.background = "linear-gradient(\n          to bottom,\n          rgba(23, 24, 32, ".concat(bgDarken, "),\n          rgba(23, 24, 32, ").concat(bgDarken, ")\n        ), ");
            }
            style.background += "url('".concat(bgImg, "')");
        } else if (bgProps) {
            style.background = bgProps;
        }
        style.backgroundSize = bgSize;
        style.backgroundPosition = bgPos;
        style.backgroundRepeat = bgRepeat;
        if (bgFixed) style.backgroundAttachment = "fixed";
        if (style.background === "") delete style.background;
        return style;
    }, [
        bgImg,
        bgProps,
        bgSize,
        bgPos,
        bgRepeat,
        bgFixed,
        bgDarken
    ]);
    var ref5 = _slicedToArray((0,react_use__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(false), 2), isTitleOpen = ref5[0], setTitleOpen = ref5[1];
    var key = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return id || "section".concat(pascalName);
    }, [
        id,
        pascalName
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .xu, _objectSpread({
        ref: handleInView ? inViewRef : undefined,
        id: key,
        className: className,
        style: _objectSpread({}, sectionStyleLocal),
        as: "section",
        bg: bg,
        overflow: "hidden",
        pb: pb,
        pt: pt,
        px: px,
        position: "relative",
        textAlign: isCentered ? "center" : undefined
    }, sectionProps, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_10__/* .AnimatePresence */ .M, {
            initial: !(disableAnimation || disableAnimationTitle),
            children: [
                _configs__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .zx, {
                    variant: "unstyled",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    onClick: function() {
                        return setTitleOpen(!isTitleOpen);
                    },
                    children: "\xa0"
                }, "".concat(key, "-titleOpenButton")),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .xu, _objectSpread({
                    color: titleColor,
                    maxW: sectionSize !== SectionSize.FIT && "7xl",
                    pb: pb,
                    pt: pt,
                    px: px,
                    mx: "auto"
                }, containerProps, {
                    children: [
                        title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .xu, _objectSpread({
                            maxW: "992px",
                            mx: "auto",
                            textAlign: "center",
                            mb: {
                                base: description ? "3rem" : "1.5rem",
                                md: description ? "5rem" : "2.5rem"
                            }
                        }, titleWrapProps, {
                            children: [
                                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_chakra_ui_framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .MotionHeading */ .xn, _objectSpread({
                                    as: "h2",
                                    textStyle: "heading"
                                }, _configs_motion_presets__WEBPACK_IMPORTED_MODULE_3__/* .motionFadeUpProps */ .E, titleProps, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .TextUnderlineDivider */ .pX, _objectSpread({
                                        colorLight: titleColor,
                                        underlineColorLight: underlineColor
                                    }, titleTextUnderlineDividerProps, {
                                        children: title
                                    }))
                                }), "".concat(key, "-title")),
                                description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_chakra_ui_framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .MotionHeading */ .xn, _objectSpread({
                                    as: "h2",
                                    textStyle: "heading"
                                }, _configs_motion_presets__WEBPACK_IMPORTED_MODULE_3__/* .motionFadeUpProps */ .E, titleProps, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .chakra.p */ .m$.p, _objectSpread({
                                        textStyle: "description"
                                    }, descriptionProps, {
                                        children: Array.isArray(description) && !isMobile ? description.map(function(item, index) {
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .xv, {
                                                children: item
                                            }, index);
                                        }) : description
                                    }))
                                }), "".concat(key, "-description"))
                            ]
                        }), "".concat(key, "-titleWrap")) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_10__/* .AnimatePresence */ .M, {
                            initial: !(disableAnimation || disableAnimationContents),
                            children: children
                        }, "".concat(key, "-contents-AnimatePresence"))
                    ]
                }), "".concat(key, "-contentsWrap"))
            ]
        }, "".concat(key, "-title-AnimatePresence"))
    }), key));
};
/* harmony default export */ __webpack_exports__["ZP"] = (GeneralSection);


/***/ }),

/***/ 6569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ t; },
  "tl": function() { return /* binding */ tl; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
var lodash = __webpack_require__(2699);
;// CONCATENATED MODULE: ./i18n/ui.json
var ui_namespaceObject = JSON.parse('{"company":{"address1":"서울특별시 강남구 언주로 432-6","address2":"성보빌딩Ⅱ 2층","brandEN":"INNO&M","brandEN2":"INNONM","brandKO":"이노앤엠","ceoName":"박관희","contactEmail":"contact@innonm.com","contactUrlExample":"https://example.com/","contactUrlKakaotalk":"http://qr.kakao.com/talk/RY90ElZfn2TMwXpdSXoBiWU2bWY-","direction":"2호선 선릉역 4번 출구","faxNum":"0504-256-8492","linkToInstagram":"https://www.instagram.com/innonm.official/","linkToKakaotalk":"http://pf.kakao.com/_xgCQvK","linkToNaverBlog":"https://blog.naver.com/innonm","phoneNum":"1668-1954","registrationNum":"389-87-02130","registrationNumMailOrder":"2021-서울강남-05124"},"pages":{"home":{"seo":{"title":"INNONM","description":"마케팅, 디테일의 차이가 결과의 차이. INNONM"},"sections":{"main-banner":{"title":{"main1":"Quality","main2":"Creativity","brand":"INNO&M"},"message1":"\\"디테일의 차이가 결과의 차이\\"","message2":""},"works":{"title":"How We Work","descriptions":["이노앤엠은 디테일을 무기로 경험, 기술, 데이터를 통한 ","다양한 솔루션을 통해 마케팅 시장을 개척하고 있습니다. ","고객사의 강점 및 분야를 분석하여 나아갈 방향을 제시해 드리겠습니다."],"item1":{"title":"정보 수집과 진단","descriptions":["Client의 브랜드 및 Service 진단 분석","경쟁사 및 시장 분석","Targeting & Positioning"]},"item2":{"title":"전략적 계획 수립","descriptions":["캠페인과 콘텐츠 전략 수립","퍼포먼스 극대화를 위한 미디어 믹스"]},"item3":{"title":"전술적 마케팅 실행","descriptions":["전략의 방향성에 의거한 Plan 실행","Operation Distribution","실행 효과 피드백 및 모니터링 보고"]},"item4":{"title":"MKT 성과 평가","descriptions":["유입 및 구매 전환 분석 평가 보고","개선사항 및 전략의 방향성 재검토","새로운 Plan의 계획과 구성"]},"item5":{"title":"브랜드 자산 증가","descriptions":["기업 가치 증대 및 고객생애 가치 획득","시장 점유율 증가 및 충성 고객 확보","Value Creation"]}},"partners":{"title":"Partners With Us"}}},"about":{"seo":{"title":"INNONM","description":"INNONM About 페이지"}},"business":{"seo":{"title":"INNONM","description":"INNONM Business 페이지"},"common":{"sections":{"about":{"name":"about","title":"바이럴 마케팅","description1":"이노앤엠은 온라인 광고에 최적화된 ","description2":"통합 마케팅을 제공합니다"}}},"viral":{"sections":{"about":{"name":"viral","title":"바이럴 마케팅"},"contents":{"title1":"바이럴 마케팅?","body1":"온라인 상의 커뮤니티 공간을 통해 자사 브랜드의 가치를 높일 수 있는 마케팅 방법이며, 광고주와 소비자 간의 양방향 소통으로 신뢰를 쌓을 수 있다는 장점이 있습니다.","title2":"바이럴 마케팅이 필요한 이유","body2-1":"기업의 브랜드 및 제품의 평판이 가장 대규모로 전파할 수 있는 공간은 카페 및 일반 커뮤니티 공간에서의 활동입니다.","body2-2":"이러한 커뮤니티 공간에 형성된 콘텐츠 및 댓글은 긍정적인 여론 형성을 통해 브랜드의 긍정적인 인지도 효과 및 매출 증대를 가져옵니다."},"works":{"title":"블로그 체험단","sections":{"blog":{"title1":"운영목적","body1-1":"브랜드의 제품&서비스 긍정 후기 확산","body1-2":"관심 고객에게 정보 제공","title2":"운영방향성","body2-1":"홍보 내용과 목적에 따라 마이크로~파워블로거 유동적 운영","body2-2":"DB를 통한 섭외 및 카테고리&주제별 개별 모집","body2-3":"풍부한 경험을 통한 최적의 키워드 추천 (쿼리수 기반)","body2-4":"최적화 블로그 여부 및 노출 관련 추천 의견 제공","title3":"기대효과","body3-1":"향후 타 매체를 통한 브랜드 검색에 신뢰성 부여","body3-2":"(언론 핫딜 카페 등을 통해 구매 전 네이버 검색시 포스팅을 통해 정보 획득)"},"sns":{"title1":"운영목적","body1-1":"브랜드&제품 긍정 후기 게시글 누적","body1-2":"구매 타겟에게 직접 노출","title2":"운영방향성","body2-1":"블로그 체험단/언론송출 등의 네이버 배포 완료 후 진행","body2-2":"모집 리스트 전달 시, 좋아요/댓글 인게이지먼트 제공","body2-3":"→ 성실 리뷰어 선정 기준 제공","body2-4":"찐 후기 중심의 피드 업로드","body2-5":"→ 구체적인 가이드를 통해 필수 소구점이 포함되면서 개성이 드러나는 찐 콘텐츠 추구","title3":"기대효과","body3-1":"제품 및 브랜드 인지도 상승","body3-2":"인플루언서를 통한 \\"트렌드\\" 확보"},"viral":{"title1":"운영목적","body1-1":"브랜드 정보, 이벤트, 행사, 신제품 홍보, 핫딜 게시판, 카페 제휴","body1-2":"","title2":"운영방향성","body2-1":"빅데이터 & 노하우를 통한 타겟층 설정","body2-2":"타겟에 맞는 고활성화 카페&커뮤니티 최다 보유!","body2-3":"","body2-4":"","title3":"기대효과","body3-1":"더 밀접한 타겟 친화 광고 가능, 이벤트 / 행사 홍보 가능","body3-2":"","title4":"작업개요","body4-1":"진행 요청 시, 추천 list up 제공","body4-2":"변수 통제를 위해 진행 전 세부상담 필수"}}}}},"sns":{"sections":{"about":{"name":"sns","title":"SNS 운영대행"},"contents":{"title1":"SNS 운영대행이란?","body1":"브랜드 아이덴티티를 반영한 컨셉 및 운영 전략을 수립하고 소비자와의 양방향 커뮤니케이션으로 브랜드 채널을 운영해드립니다.","title2":"SNS 운영대행이 필요한 이유","body2":"소셜 네크워크 서비스의 운영은 기업의 단계적인 소셜 인프라 구축 및 소통, 브랜드 정체성(아이덴티티)을 확보해가면서 소비자에게 진정성있는 접근을 유도하여 기업 브랜드 가치 및 매출 상승에 중요한 역할을 합니다."},"specialty":{"description1":"풍부한 경험과 노하우가 축적된 자사의 SNS 관리 프로세스를 통해 체계적인 관리가 가능합니다","description2":"진정성 있는 콘텐츠로 소비자와의 소통이 이루어지는 생동감 넘치는 브랜드 페이지 구축이 가능합니다"}}},"searchad":{"sections":{"about":{"name":"searchad","title":"검색 광고"},"contents":{"title1":"검색 광고란?","body1":"국내외 포털 사이트 내 키워드 검색 시 노출 되는 광고로 포털 사이트 상단에 노출됩니다. 소비자의 의사가 반영된 검색어를 통해 노출되는 광고로 효율이 우수한 광고 상품입니다.","title2":"","body2":""},"specialty":{"description1":"풍부한 경험과 노하우가 축적된 자사의 SNS 관리 프로세스를 통해 체계적인 관리가 가능합니다","description2":"진정성 있는 콘텐츠로 소비자와의 소통이 이루어지는 생동감 넘치는 브랜드 페이지 구축이 가능합니다"}}},"media":{"sections":{"about":{"name":"media","title":"언론 송출"},"contents":{"title1":"바이럴 마케팅?","body1":"기업 및 브랜드에 있어서 가장 직접적인 PR방법으로 기업의 이슈를 보도매체를 통해 뉴스기사를 송부하여 주요 포털 사이트인 네이버, 다음, 네이트에 클라이언트 기업의 브랜드 및 상품을 송출합니다.","title2":"언론 송출이 필요한 이유","body2":"클라이언트 기업의 브랜드 및 상품을 노출 시킴으로서 소비자로 하여금 기업 및 브랜드를 신뢰하게 합니다."}}}},"notfound":{"title":"404: Not found","description":"Page not found","heading":"404 | Page Not Found","message1":"요청하신 페이지가 아직 존재하지 않습니다.","message2":"최대한 빠르게 준비해드리겠습니다.","back-to-home":"홈으로 돌아가기"}},"layout":{"footer":{"title":"INNO&M","proudly-made-in":"Proudly made in"},"mobile-nav":{"docs":"Docs","guides":"Guides","resources":"Resources","faq":"FAQ","team":"Team","showcase":"Showcase"}},"view":{"sections":{"location":{"title":"Where We Works"},"contact":{"title":"Contact Us"}}}}');
;// CONCATENATED MODULE: ./src/utils/i18n.ts


var t = function(str) {
    // TODO: load the locale appropriate ui.json file
    var result = (0,lodash.get)(ui_namespaceObject, str);
    if (typeof result !== "string") {
        throw new Error("Translation not found for ".concat(str));
    }
    return result;
};
var isStringArray = function(test) {
    return Array.isArray(test) && !test.some(function(value) {
        return typeof value !== "string";
    });
};
var tl = function(str) {
    // TODO: load the locale appropriate ui.json file
    var result = (0,lodash.get)(ui_namespaceObject, str);
    // let fail = false;
    // if (!Array.isArray(result)) {
    //   fail = true;
    // } else {
    //   result.forEach((item) => {
    //     if (typeof item !== `string`) {
    //       fail = true;
    //     }
    //   });
    // }
    // if (fail) {
    //   throw new Error(`Translation not found for ${str}`);
    // } else {
    //   return result;
    // }
    if (!isStringArray(result)) {
        throw new Error("Translation not found for ".concat(str));
    } else {
        return result;
    }
};


/***/ }),

/***/ 7925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__": function() { return /* reexport */ too_lodash; },
  "xN": function() { return /* reexport */ createLog; },
  "t": function() { return /* reexport */ i18n.t; },
  "by": function() { return /* reexport */ use_grid_props; },
  "Tx": function() { return /* reexport */ useLog; },
  "Fs": function() { return /* reexport */ useStateL; }
});

// UNUSED EXPORTS: Media, MediaContextProvider, mediaStyle, useReducerL

// EXTERNAL MODULE: ./node_modules/.pnpm/@artsy+fresnel@3.4.0_react@17.0.2/node_modules/@artsy/fresnel/dist/index.js
var dist = __webpack_require__(1682);
;// CONCATENATED MODULE: ./src/utils/media-detector.ts

var breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};
var Boostrap4Media = (0,dist/* createMedia */.Wm)({
    breakpoints: breakpoints
});
// Make styles for injection into the header of the page
var mediaStyle = Boostrap4Media.createMediaStyle();
var Media = Boostrap4Media.Media, MediaContextProvider = Boostrap4Media.MediaContextProvider;

// EXTERNAL MODULE: ./node_modules/.pnpm/chalk@4.1.2/node_modules/chalk/source/index.js
var source = __webpack_require__(748);
var source_default = /*#__PURE__*/__webpack_require__.n(source);
// EXTERNAL MODULE: ./node_modules/.pnpm/loglevel@1.8.0/node_modules/loglevel/lib/loglevel.js
var loglevel = __webpack_require__(919);
var loglevel_default = /*#__PURE__*/__webpack_require__.n(loglevel);
// EXTERNAL MODULE: ./node_modules/.pnpm/loglevel-plugin-prefix@0.8.4/node_modules/loglevel-plugin-prefix/lib/loglevel-plugin-prefix.js
var loglevel_plugin_prefix = __webpack_require__(226);
var loglevel_plugin_prefix_default = /*#__PURE__*/__webpack_require__.n(loglevel_plugin_prefix);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./configs/index.ts + 5 modules
var configs = __webpack_require__(9457);
;// CONCATENATED MODULE: ./src/utils/log-provider.ts






function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var colors = {
    TRACE: (source_default()).gray,
    DEBUG: (source_default()).magenta,
    INFO: (source_default()).blue,
    WARN: (source_default()).yellow,
    ERROR: (source_default()).red
};
var createRootLogger = function(log, nodeEnv) {
    var localNodeEnv = nodeEnv || configs/* NODE_ENV */.lC;
    var lvl = "info";
    if (localNodeEnv === configs/* NodeEnv.PROD */.$X.PROD) lvl = "warn";
    else if (localNodeEnv === configs/* NodeEnv.DEVELOP */.$X.DEVELOP) lvl = "debug";
    else if (localNodeEnv === configs/* NodeEnv.TEST */.$X.TEST) lvl = "info";
    else throw new Error("nodeEnv is unknown value (".concat(localNodeEnv, ")"));
    if (configs/* Configs.isVerboseMode */.zo.isVerboseMode()) {
        lvl = "trace";
        log.debug("set loglevel to '".concat(lvl, "'"));
        log.debug("loglevel: ".concat(log.getLevel()));
    }
    log.setLevel(lvl);
    return log;
};
var createPrefixedLogger = function(nodeEnv, logName) {
    var rootLogger = createRootLogger((loglevel_default()), nodeEnv);
    loglevel_plugin_prefix_default().reg(rootLogger);
    rootLogger.enableAll();
    loglevel_plugin_prefix_default().apply(rootLogger.getLogger(logName || "root"), {
        format: function format(level, name, timestamp) {
            return "".concat(source_default().gray("[".concat(timestamp, "]")), " [").concat(colors[level.toUpperCase()](level.toUpperCase().slice(0, 6).padEnd(5)), "] [").concat(source_default().green("".concat(name)), "]");
        }
    });
    loglevel_plugin_prefix_default().apply(rootLogger.getLogger("critical"), {
        format: function format(level, name, timestamp) {
            return source_default().red.bold("[".concat(timestamp, "] [").concat(level.toUpperCase().slice(0, 6).padEnd(5), "] [").concat(name, "]"));
        }
    });
    var log = rootLogger.getLogger(logName || "root");
    if (configs/* Configs.isVerboseMode */.zo.isVerboseMode()) {
        log.debug("prefixedLogger created with name '".concat(logName || "root", "'"));
    }
    return log;
};
var createLog = function(name) {
    return createPrefixedLogger(configs/* NODE_ENV */.lC, name);
};
// export const useLog = (name: string): Logger => {
//   return useMemo(() => createLog(name), [name]);
// };
var useLog = function(name) {
    var ref = _slicedToArray(useStateL(createLog(name), "log"), 2), log = ref[0], setLog = ref[1];
    (0,react.useEffect)(function() {
        setLog(createLog(name));
    }, [
        name,
        setLog
    ]);
    return log;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
var lodash = __webpack_require__(2699);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./src/utils/too-lodash/__obj.ts

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var getSortedKeys = function(obj) {
    var keys = Object.keys(obj);
    return lodash_default().sortBy(keys);
};
var isBlankOrEmpty = function(value) {
    return lodash_default().isString(value) ? !lodash_default().trim(value) : lodash_default().isEmpty(value);
};
var sortByKeys = function(object) {
    var sortedKeys = getSortedKeys(object);
    return lodash_default().map(sortedKeys, function(key) {
        return _defineProperty({}, key, object[key]);
    });
};
var __obj = {
    getSortedKeys: getSortedKeys,
    isBlankOrEmpty: isBlankOrEmpty,
    sortByKeys: sortByKeys
};
/* harmony default export */ var _obj = (__obj);

;// CONCATENATED MODULE: ./src/utils/too-lodash/__str.ts


var isBlank = function(str) {
    return !lodash_default().trim(str);
};
var objectJoinToString = function(object, separator, keys) {
    var picked;
    if (keys && keys.length > 0) {
        picked = lodash_default().pick(object, keys);
    } else {
        picked = object;
    }
    if (!separator) {
        separator = ",";
    }
    var sortedKeys = _obj.getSortedKeys(picked);
    // console.log(sortedKeys)
    var mapped = lodash_default().map(sortedKeys, function(key, idx) {
        return "".concat(separator).concat(picked[sortedKeys[idx]]);
    }).join("");
    // console.log(mapped)
    return mapped;
};
var pascalCase = function(str) {
    return lodash_default().upperFirst(lodash_default().camelCase(str));
};
var toBoolean = function(str) {
    return JSON.parse(str);
};
var toBooleanHuman = function(str) {
    switch(str.toLowerCase().trim()){
        case "true":
        case "yes":
        case "1":
            return true;
        case "false":
        case "no":
        case "0":
        case null:
            return false;
        default:
            return Boolean(str);
    }
};
var __str = {
    isBlank: isBlank,
    objectJoinToString: objectJoinToString,
    pascalCase: pascalCase,
    toBoolean: toBoolean,
    toBooleanHuman: toBooleanHuman
};
/* harmony default export */ var _str = (__str);

;// CONCATENATED MODULE: ./src/utils/too-lodash/__css.ts
// import _ from 'lodash';

var buildCss = function(object, keys) {
    return _str.objectJoinToString(object, " ", keys);
};
var generateBuildBgImg = function(param) {
    var path = param.path, _fileExt = param.fileExt, fileExt = _fileExt === void 0 ? "" : _fileExt, _bgAlpha = param.bgAlpha, bgAlpha = _bgAlpha === void 0 ? 0 : _bgAlpha, _bgAlphaColor = param.bgAlphaColor, bgAlphaColor = _bgAlphaColor === void 0 ? "23, 24, 32" : _bgAlphaColor;
    return function(filename) {
        return "linear-gradient(rgba(".concat(bgAlphaColor, ", ").concat(bgAlpha, "), rgba(").concat(bgAlphaColor, ", ").concat(bgAlpha, ")), url('").concat(path, "/").concat(filename).concat(fileExt, "')");
    };
};
var __css = {
    buildCss: buildCss,
    generateBuildBgImg: generateBuildBgImg
};
/* harmony default export */ var _css = (__css);

;// CONCATENATED MODULE: ./src/utils/too-lodash/index.ts



function too_lodash_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            too_lodash_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var __ = _objectSpread({}, _css, _obj, _str);
/* harmony default export */ var too_lodash = (__);


// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.3.2_react-dom@17.0.2_react@17.0.2/node_modules/react-use/esm/useWindowSize.js + 3 modules
var useWindowSize = __webpack_require__(5961);
;// CONCATENATED MODULE: ./src/types/bootstrap-types.ts
var GridBreakpoints;
(function(GridBreakpoints) {
    GridBreakpoints[GridBreakpoints["XS"] = 0] = "XS";
    GridBreakpoints[GridBreakpoints["SM"] = 576] = "SM";
    GridBreakpoints[GridBreakpoints[// SM = 480,
    "MD"] = 768] = "MD";
    GridBreakpoints[GridBreakpoints["LG"] = 992] = "LG";
    GridBreakpoints[GridBreakpoints["XL"] = 1200] = "XL";
    GridBreakpoints[GridBreakpoints[// XL = 1280,
    "XXL"] = 1400] = "XXL";
    GridBreakpoints[GridBreakpoints["UNKNOWN"] = -1] = "UNKNOWN";
})(GridBreakpoints || (GridBreakpoints = {}));
var ContainerMaxWidths;
(function(ContainerMaxWidths) {
    ContainerMaxWidths[ContainerMaxWidths["XS"] = 0] = "XS";
    ContainerMaxWidths[ContainerMaxWidths["SM"] = 540] = "SM";
    ContainerMaxWidths[ContainerMaxWidths["MD"] = 720] = "MD";
    ContainerMaxWidths[ContainerMaxWidths["LG"] = 960] = "LG";
    ContainerMaxWidths[ContainerMaxWidths["XL"] = 1140] = "XL";
    ContainerMaxWidths[ContainerMaxWidths["XXL"] = 1320] = "XXL";
    ContainerMaxWidths[ContainerMaxWidths["UNKNOWN"] = -1] = "UNKNOWN";
})(ContainerMaxWidths || (ContainerMaxWidths = {}));

;// CONCATENATED MODULE: ./src/utils/use-grid-props.ts




var log = createLog("useGridProps");
var getGridBreakpoint = function(windowSize) {
    var width = windowSize.width;
    if (GridBreakpoints.XS <= width && width < GridBreakpoints.SM) return GridBreakpoints.XS;
    if (GridBreakpoints.SM <= width && width < GridBreakpoints.MD) return GridBreakpoints.SM;
    if (GridBreakpoints.MD <= width && width < GridBreakpoints.LG) return GridBreakpoints.MD;
    if (GridBreakpoints.LG <= width && width < GridBreakpoints.XL) return GridBreakpoints.LG;
    if (GridBreakpoints.XL <= width) return GridBreakpoints.XL;
    return GridBreakpoints.UNKNOWN;
};
var getContainerMaxWidth = function(windowSize) {
    var width = windowSize.width;
    if (ContainerMaxWidths.XS <= width && width < ContainerMaxWidths.SM) return ContainerMaxWidths.XS;
    if (ContainerMaxWidths.SM <= width && width < ContainerMaxWidths.MD) return ContainerMaxWidths.SM;
    if (ContainerMaxWidths.MD <= width && width < ContainerMaxWidths.LG) return ContainerMaxWidths.MD;
    if (ContainerMaxWidths.LG <= width && width < ContainerMaxWidths.XL) return ContainerMaxWidths.LG;
    if (ContainerMaxWidths.XL <= width) return ContainerMaxWidths.XL;
    return ContainerMaxWidths.UNKNOWN;
};
var useGridProps = function() {
    var windowSize = (0,useWindowSize/* default */.Z)();
    var ref = (0,react.useMemo)(function() {
        var lContainerMaxWidth = getContainerMaxWidth(windowSize);
        var lGridBreakpoint = getGridBreakpoint(windowSize);
        var gridProps = {
            containerMaxWidth: lContainerMaxWidth,
            gridBreakpoint: lGridBreakpoint,
            isDesktop: lGridBreakpoint > GridBreakpoints.MD,
            isMobile: lGridBreakpoint < GridBreakpoints.MD
        };
        // log.debug(`gridProps: ${JSON.stringify(gridProps)}`);
        return gridProps;
    }, [
        windowSize
    ]), gridBreakpoint = ref.gridBreakpoint, containerMaxWidth = ref.containerMaxWidth, isDesktop = ref.isDesktop, isMobile = ref.isMobile;
    return {
        containerMaxWidth: containerMaxWidth,
        gridBreakpoint: gridBreakpoint,
        isDesktop: isDesktop,
        isMobile: isMobile
    };
};
/* harmony default export */ var use_grid_props = (useGridProps);

;// CONCATENATED MODULE: ./src/utils/use-reducer-l.ts

function useReducerL(label, reducer, initialArgs, init) {
    var ref = useReducer(reducer, initialArgs, init), state = ref[0], dispatch = ref[1];
    useDebugValue("".concat(label, ": ").concat(JSON.stringify(state)));
    return [
        state,
        dispatch
    ];
};

;// CONCATENATED MODULE: ./src/utils/use-state-l.ts

function useStateL(initialValue, label) {
    var ref = (0,react.useState)(initialValue), value = ref[0], setValue = ref[1];
    (0,react.useDebugValue)("".concat(label, ": ").concat(value));
    return [
        value,
        setValue
    ];
};

// EXTERNAL MODULE: ./src/utils/i18n.ts + 1 modules
var i18n = __webpack_require__(6569);
;// CONCATENATED MODULE: ./src/utils/index.ts









/***/ }),

/***/ 1609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"content-section_contentSection__jpIDy","sectionBanner":"content-section_sectionBanner__52QcE","bgDark":"content-section_bgDark__nSsIq","bgGray":"content-section_bgGray__JGspp","bgLight":"content-section_bgLight__ss35s","colorLight":"content-section_colorLight__dT4dJ","titleWrap":"content-section_titleWrap__sq3sO","subtitle":"content-section_subtitle__O969e","title":"content-section_title__LX1NU","isCentered":"content-section_isCentered__XSddL","isFullHeight":"content-section_isFullHeight__OsO54","isFullWidth":"content-section_isFullWidth__BkxvC","contentWrap":"content-section_contentWrap__3W_Kt","titleSeparatorDefault":"content-section_titleSeparatorDefault__59Kfy","titleSeparatorDark":"content-section_titleSeparatorDark__ts1_0","titleSeparatorNone":"content-section_titleSeparatorNone__Dhp3M","content":"content-section_content__db1L6","contentBody":"content-section_contentBody__rZDjy","isOverflowVisible":"content-section_isOverflowVisible___7ixN"};

/***/ })

}]);